/* eslint-disable */
import React, { useState, useEffect, Component } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { message, Upload, Progress } from "antd";
import { RotateCw } from "lucide-react";
import { CloseOutlined, DeleteOutlined, CopyOutlined } from "@ant-design/icons";
import Spinner from "react-bootstrap/Spinner";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { RefreshCcw } from "lucide-react";
// import FoorchatAdsIdsManager from "../../chatbot/productShow";

import {
  addDoc,
  collection,
  serverTimestamp,
  setDoc,
  doc,
  updateDoc,
  arrayRemove,
  deleteField,
} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import QuillEditor from "./TextEditor";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addProduct, updateProduct } from "../../../redux/products/products";
import apicacheProduct from "../../clearCach/clearProduct";
import ConfirmDialog from "../../ConfirmDialog";

import DigitalProductForm from "./DigitalProductForm";

import countriesData from "../../../utils/countries.json";
import { DEFAULT_WILAYAS } from "../../../constants/default_wilaya";
import axios from "axios";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const normalizeSubOptionChoice = (choice, currencySymbol) => {
  if (typeof choice !== "string") return choice;

  const trimmedChoice = choice.trim();
  const trimmedCurrency = String(currencySymbol || "").trim();
  if (!trimmedCurrency) return trimmedChoice;

  const priceSuffix = new RegExp(
    `-\\s*\\d+(?:[.,]\\d+)?\\s*x\\s*${escapeRegExp(trimmedCurrency)}\\s*$`,
    "i",
  );

  return trimmedChoice.replace(priceSuffix, "").trim();
};

const ModelAdd = ({
  lgShow,
  setLgShow,
  data,
  setData,
  categories,
  hideProductDescription = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.StoreReducer);
  const digitalStore = useSelector((state) => state.digitalStoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  // const products = useSelector((state) => state.ProductsReducer);
  const { t, i18n } = useTranslation();
  const [duplicateLoading, setDuplicateLoading] = useState(false);
  const [originalData, setOriginalData] = useState(data);
  const [newAdsId, setNewAdsId] = useState("");

  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setFileList([]);
    setLgShow(false);
  };

  const [deliveryOption, setDeliveryOption] = useState(null);

  const handleDeliveryOptionChange = (value) => {
    setDeliveryOption(value);
    setData((prev) => ({
      ...prev,
      delevery: value === "free",
      isConstantPriceDelivery: value === "constant",
      isWilayaDefault: value === "default",
      isStoreDelivery: value === "store",
    }));
  };

  useEffect(() => {
    if (data) {
      let optionToSet = "store";

      if (data.delevery === true) {
        optionToSet = "free";
      } else if (data.isConstantPriceDelivery === true) {
        optionToSet = "constant";
        setConstantPriceValue(data.constantPrice || 0);
      } else if (data.isWilayaDefault === true) {
        optionToSet = "default";
      } else if (data.isStoreDelivery === true) {
        optionToSet = "store";
      } else {
        // Check if user has customized individual wilaya prices
        const hasCustomPrices =
          data.states &&
          data.states.some(
            (state) => state.price && state.price !== "" && state.hide === true,
          );

        if (hasCustomPrices) {
          optionToSet = "default";
        } else {
          optionToSet = "store";
        }
      }

      setDeliveryOption((prev) => {
        if (prev !== optionToSet) {
          return optionToSet;
        }
        return prev;
      });
    }
  }, [
    data?.delevery,
    data?.isConstantPriceDelivery,
    data?.isWilayaDefault,
    data?.isStoreDelivery,
    data?.constantPrice,
  ]);

  const handleAddAdsId = () => {
    const id = newAdsId.trim();
    if (!id) return;

    const current = Array.isArray(data.adsIds) ? data.adsIds : [];
    if (current.includes(id)) return; // avoid duplicates

    setData({
      ...data,
      adsIds: [...current, id],
    });
    setNewAdsId("");
  };

  const handleRemoveAdsId = (index) => {
    const current = Array.isArray(data.adsIds) ? data.adsIds : [];
    setData({
      ...data,
      adsIds: current.filter((_, i) => i !== index),
    });
  };

  const [constantPriceValue, setConstantPriceValue] = useState(null);
  const [filter, setFilter] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCountries, setSelectedCountries] = useState(() => {
    if (data?.cloakingTown?.length > 0) {
      return data.cloakingTown
        .map((code) => {
          const country = countriesData.find((c) => c.alpha2_code === code);
          if (country) {
            return {
              code: country.alpha2_code,
              name: country.arabic_name,
              englishName: country.english_name,
              phoneCode: country.phone_code,
            };
          }
          return null;
        })
        .filter(Boolean);
    }
    return [];
  });

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const countries = countriesData;

  const filteredCountries = countries.filter(
    (country) =>
      country.arabic_name.includes(searchQuery) ||
      country.english_name.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const [cloakingTownRawData, setCloakingTownRawData] = useState([]);

  useEffect(() => {
    if (data?.cloakingTown?.length > 0) {
      setCloakingTownRawData(data.cloakingTown);
    } else {
      setCloakingTownRawData([]);
    }
  }, [data]);

  const onDeleteCountry = async (countryCode) => {
    try {
      const productRef = doc(db, "products", data.id);
      await updateDoc(productRef, {
        cloakingTown: arrayRemove(countryCode),
      });

      // Update both states
      const updatedCloakingTown = cloakingTownRawData.filter(
        (code) => code !== countryCode,
      );
      setCloakingTownRawData(updatedCloakingTown);

      // Remove from selectedCountries
      const updatedSelectedCountries = selectedCountries.filter(
        (country) => country.code !== countryCode,
      );
      setSelectedCountries(updatedSelectedCountries);
    } catch (e) {
      console.error(t("Products.modalAdd.countryDeleteError"), e);
    }
  };

  useEffect(() => {
    if (data?.cloakingTown?.length > 0) {
      const countriesFromData = data.cloakingTown
        .map((code) => {
          const country = countriesData.find((c) => c.alpha2_code === code);
          if (country) {
            return {
              code: country.alpha2_code,
              name: country.arabic_name,
              englishName: country.english_name,
              phoneCode: country.phone_code,
            };
          }
          return null;
        })
        .filter(Boolean);

      setSelectedCountries(countriesFromData);
      setCloakingTownRawData(data.cloakingTown);
    } else {
      setSelectedCountries([]);
      setCloakingTownRawData([]);
    }
  }, [data?.cloakingTown]);

  const selectedCountry = store?.country || "الجزائر";
  const isAlgeria = selectedCountry === "الجزائر";
  const [isLimitedValueModalOpen, setIsLimitedValueModalOpen] = useState(false);
  const [limitedValue, setLimitedValue] = useState(0);

  // Open and close modal
  const openLimitedValueModal = () => {
    setIsLimitedValueModalOpen(true);
  };

  const closeLimitedValueModal = () => {
    setIsLimitedValueModalOpen(false);
  };

  // Handle Limited Value Modal submission
  const handleSubmitLimitedValue = () => {
    setLoading(true);

    try {
      Swal.fire({
        icon: "success",
        title: t("Products.modalAdd.submitLimitedValue1"),
        text: t("Products.modalAdd.submitLimitedValue2"),
        confirmButtonText: t("Products.modalAdd.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });

      closeLimitedValueModal();
    } catch (error) {
      console.error("Error saving limited value:", error);
      Swal.fire({
        icon: "error",
        title: t("Products.modalAdd.submitLimitedValue4"),
        text: error.message,
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } finally {
      setLoading(false);
    }
  };

  // خاصية تكرار المنتج
  const handleDuplicateProduct = async () => {
    if (!data.id) {
      Swal.fire({
        icon: "warning",
        title: t("Products.modalAdd.submitduplicateAlert"),
        text: t("Products.modalAdd.submitduplicateAlert2"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      return;
    }

    try {
      setDuplicateLoading(true);

      // إنشاء نسخة من المنتج مع تعديل بعض البيانات
      const duplicatedProduct = {
        ...data,
        url: `${data.url}-copy-${Date.now()}`,
        sku: `${data.sku}-COPY-${Date.now()}`,
        timeStamp: serverTimestamp(),
        visits: 0,
        user: account.user,
      };

      const docRef = await addDoc(
        collection(db, "products"),
        duplicatedProduct,
      );
      await updateDoc(docRef, { id: docRef.id });

      setData({
        ...duplicatedProduct,
        id: docRef.id,
      });

      Swal.fire({
        icon: "success",
        title: t("Products.modalAdd.submitduplicate"),
        text: t("Products.modalAdd.submitduplicate2"),
        confirmButtonText: t("Products.modalAdd.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });

      // تحديث الكاش
      apicacheProduct(account, data.url);
    } catch (error) {
      console.error("Error duplicating product:", error);
      Swal.fire({
        icon: "error",
        title: t("Products.modalAdd.submitduplicateerror"),
        text: error.message,
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } finally {
      setDuplicateLoading(false);
    }
  };

  useEffect(() => {
    if (data && data.limitedValue !== undefined) {
      setLimitedValue(data.limitedValue);
    }
  }, [data]);

  const [isInfinityDialogOpen, setIsInfinityDialogOpen] = useState(false);

  const openInfinityDialog = () => setIsInfinityDialogOpen(true);
  const closeInfinityDialog = () => setIsInfinityDialogOpen(false);

  const [isInfinity, setIsInfinity] = useState(false);

  const handleInfinityConfirm = () => {
    if (isInfinity) {
      setIsInfinity(false);

      Swal.fire({
        icon: "success",
        title: t("Products.modalAdd.submitInfinityConfirm1"),
        text: t("Products.modalAdd.submitInfinityConfirm2"),
        confirmButtonText: t("Products.modalAdd.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } else {
      setIsInfinity(true);

      Swal.fire({
        icon: "success",
        title: t("Products.modalAdd.submitInfinityConfirm3"),
        text: t("Products.modalAdd.submitInfinityConfirm4"),
        confirmButtonText: t("Products.modalAdd.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    }

    closeInfinityDialog();
  };

  const [isAddOptionDropdownOpen, setIsAddOptionDropdownOpen] = useState(false);

  // Toggle the dropdown visibility
  const toggleAddOptionDropdown = () => {
    setIsAddOptionDropdownOpen(!isAddOptionDropdownOpen);
  };

  const addOption1 = () => {
    setData({
      ...data,
      options: [
        ...data.options,
        {
          title: t("Products.modalAdd.tab2.defaultColorTitle"),
          color: "1",
          colorOption: [
            {
              option: "",
              color: "",
              skuEnabled: false,
              sku: "",
            },
          ],
        },
      ],
    });
    setIsAddOptionDropdownOpen(false);
  };

  const addOption2 = () => {
    setData({
      ...data,
      options: [
        ...data.options,
        {
          title: t("Products.modalAdd.tab2.defaultCustomTitle"),
          color: "0",
          colorOption: [],
        },
      ],
    });
    setIsAddOptionDropdownOpen(false);
  };

  // Handle main form submission (file upload, product data)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const requiredFields = ["price", "name", "sku", "url"];
      const fieldLabels = {
        name: t("Products.modalAdd.form.name.label"),
        price: t("Products.modalAdd.form.price.label"),
        sku: t("Products.modalAdd.form.sku.label"),
        url: t("Products.modalAdd.form.url.label"),
      };
      if (data.type === "digitalProducts") {
        requiredFields.push("digitalInfo");
        fieldLabels.digitalInfo = t("Products.modalAdd.form.digitalInfo.label");
      }
      const missingFields = requiredFields.filter(
        (field) => !data[field] || data[field].toString().trim() === "",
      );

      if (missingFields.length > 0) {
        const missingFieldNames = missingFields.map(
          (field) => fieldLabels[field] || field,
        );
        Swal.fire({
          icon: "warning",
          title: t("Products.modalAdd.validation.requiredTitle"),
          text: t("Products.modalAdd.validation.missingFields", {
            fields: missingFieldNames.join(
              t("Products.modalAdd.validation.listSeparator"),
            ),
          }),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
        setLoading(false);
        return;
      }

      let totalOptionsQuantity = 0;
      let quantityPaths = [];

      const findAllQuantities = (obj, path = "") => {
        if (!obj || typeof obj !== "object") return;

        Object.keys(obj).forEach((key) => {
          const value = obj[key];
          const newPath = path ? `${path}.${key}` : key;

          if (key === "quantity" && !isNaN(parseInt(value, 10))) {
            const qty = parseInt(value, 10);
            totalOptionsQuantity += qty;
            quantityPaths.push({ path: newPath, quantity: qty });
          }

          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              if (typeof item === "object" && item !== null) {
                findAllQuantities(item, `${newPath}[${index}]`);
              }
            });
          } else if (typeof value === "object" && value !== null) {
            findAllQuantities(value, newPath);
          }
        });
      };

      if (data.options) {
        findAllQuantities(data.options, "options");
      }

      // Only proceed with validation if we found quantities and have a main qty
      if (quantityPaths.length > 0 && data.qty) {
        const mainQty = parseInt(data.qty, 10);

        // Compare with main quantity field
        if (totalOptionsQuantity > mainQty) {
          // Total options quantity exceeds main quantity
          const result = await Swal.fire({
            icon: "warning",
            title: t("Products.modalAdd.quantity.warningTitle"),
            text: t("Products.modalAdd.quantity.exceedsMain", {
              optionsQty: totalOptionsQuantity,
              mainQty,
            }),
            showCancelButton: true,
            confirmButtonText: t("Products.modalAdd.quantity.updateMain"),
            cancelButtonText: t("Products.modalAdd.quantity.reviewOptions"),
            confirmButtonColor: "rgb(141, 93, 167)",
          });

          if (result.isConfirmed) {
            data.qty = totalOptionsQuantity.toString();
          } else {
            // User wants to review options
            setLoading(false);
            return;
          }
        } else if (totalOptionsQuantity < mainQty) {
          // Warn that not all quantity is allocated to options
          await Swal.fire({
            icon: "info",
            title: t("Products.modalAdd.quantity.infoTitle"),
            text: t("Products.modalAdd.quantity.unallocated", {
              remaining: mainQty - totalOptionsQuantity,
              mainQty,
              optionsQty: totalOptionsQuantity,
            }),
            confirmButtonText: t("Products.modalAdd.quantity.continue"),
            confirmButtonColor: "rgb(141, 93, 167)",
          });
        } else {
          console.log(
            "options quantity equals main quantity, no warnings needed.",
          );
        }
      } else {
        console.log(
          "no quantity validation performed: either no quantities found or no main qty",
        );
      }
      const gallery = [];

      if (fileList.length > 0) {
        for (let i = 0; i < fileList.length; i++) {
          const file = fileList[i];
          const dataImage = new FormData();
          dataImage.append(
            "upload",
            file.originFileObj,
            `${Date.now()}-${file.name}`,
          );

          await sleep(3000);
          const response = await axios.post(
            "https://octopus-app-i4ylg.ondigitalocean.app/upload",
            dataImage,
            {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            },
          );

          if (i === 0 && !data.image) data.image = response.data.url;
          if (response.data.url) gallery.push(response.data.url);
        }
      }

      // Prepare delivery data based on the selected delivery option
      const deliveryData = (() => {
        switch (deliveryOption) {
          case "store":
            return {
              isWilayaDefault: false,
              isConstantPriceDelivery: false,
              delevery: false,
              // states: [],
            };
          case "constant":
            return {
              isWilayaDefault: false,
              isConstantPriceDelivery: true,
              constantPrice: constantPriceValue,
              delevery: false,
              // states: [],
            };
          case "free":
            return {
              isWilayaDefault: false,
              isConstantPriceDelivery: false,
              delevery: true,
              // states: [],
            };
          case "default":
            const wilayasToUse = (
              data.states?.length ? data.states : DEFAULT_WILAYAS
            ).map((wilaya) => {
              if (wilaya.hide) {
                return {
                  ...wilaya,

                  stopdesk:
                    wilaya.stopdesk ||
                    t("Products.modalAdd.tab3.officeDefault"),
                  pricestopdesk:
                    wilaya.pricestopdesk === "" ? 0 : wilaya.pricestopdesk || 0,
                };
              }
              return wilaya;
            });

            return {
              isWilayaDefault: true,
              isConstantPriceDelivery: false,
              delevery: false,
              states: wilayasToUse,
            };
          default:
            return {};
        }
      })();

      const normalizedOptions = Array.isArray(data.options)
        ? data.options.map((option) => ({
            ...option,
            colorOption: Array.isArray(option.colorOption)
              ? option.colorOption.map((colorOption) => ({
                  ...colorOption,
                  sizeColor: Array.isArray(colorOption.sizeColor)
                    ? colorOption.sizeColor.map((subOption) => ({
                        ...subOption,
                        choice: normalizeSubOptionChoice(
                          subOption.choice,
                          store?.currencySymbol,
                        ),
                      }))
                    : colorOption.sizeColor,
                }))
              : option.colorOption,
          }))
        : data.options;

      const productData = {
        ...data,
        options: normalizedOptions,
        type: data.type || "classic",
        ...deliveryData,
        gallery: [...new Set([...(data.gallery || []), ...gallery])].filter(
          Boolean,
        ),
        // Set main image (use existing, first of new uploads, or null)
        image: data.image || gallery[0] || null,
        user: account.user,

        timeStamp: data.id ? data.timeStamp : serverTimestamp(),
        limitedValue: limitedValue,
        isInfinity: isInfinity,
        cloakingTown: selectedCountries.map((country) => country.code),

        // Foorchat bot customization fields (tab5)
        botButton: data.botButton || t("Products.modalAdd.tab5.button"),
        botDescription: data.botDescription || "",
        botPhone: data.botPhone || "",
        deliverySociety: data.deliverySociety || "",
        adsIds: Array.isArray(data.adsIds) ? data.adsIds : [],
      };
      const cleanData = (obj) => {
        Object.keys(obj).forEach((key) => {
          if (obj[key] === undefined) delete obj[key];
          if (typeof obj[key] === "object" && obj[key] !== null)
            cleanData(obj[key]);
        });
        return obj;
      };

      const galleryOld = Array.isArray(originalData?.gallery)
        ? originalData.gallery
        : [];
      const galleryNew = Array.isArray(data.gallery) ? data.gallery : [];

      const galleryChanged =
        galleryOld.length !== galleryNew.length ||
        galleryOld.some((url, i) => url !== galleryNew[i]) ||
        fileList.length > 0;

      const imageChanged = data.image !== originalData?.image;
      const textChanged =
        (data.textEditor || "").trim() !==
        (originalData?.textEditor || "").trim();

      const cleaned = cleanData(productData);
      cleaned.galleryServerDz = [];
      let savedProductId = data.id || null;

      if (galleryChanged || imageChanged || textChanged) {
        const deletionPayload = {
          newGallery: deleteField(),
          newImage: deleteField(),
          newTextEditor: deleteField(),
          cdnfoorwebMigrated: deleteField(),
          cdnfoorwebMigrationDate: deleteField(),
          cdnfoorwebUploadthingBackup: deleteField(),
        };

        if (data.id) {
          const ref = doc(db, "products", data.id);
          await setDoc(
            ref,
            { ...cleaned, ...deletionPayload },
            { merge: true },
          );
          savedProductId = data.id;
        } else {
          const docRef = await addDoc(collection(db, "products"), cleaned);
          await updateDoc(docRef, deletionPayload);
          await updateDoc(docRef, { id: docRef.id });
          savedProductId = docRef.id;
        }
      } else {
        if (data.id) {
          await setDoc(doc(db, "products", data.id), cleaned, { merge: true });
          savedProductId = data.id;
        } else {
          const docRef = await addDoc(collection(db, "products"), cleaned);
          await updateDoc(docRef, { id: docRef.id });
          savedProductId = docRef.id;
        }
      }

      const savedProduct = {
        ...cleaned,
        id: savedProductId,
      };

      if (data.id) {
        dispatch(updateProduct(savedProduct));
      } else {
        dispatch(addProduct(savedProduct));
      }

      // Clear temporary uploads after successful submission
      setFileList([]);

      // Success notification
      Swal.fire({
        icon: "success",
        title: data.id
          ? t("Products.modalAdd.save.updated")
          : t("Products.modalAdd.save.created"),
        confirmButtonText: t("Products.modalAdd.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });

      handleClose();
      apicacheProduct(account, data.url);

      if (resetForm) resetForm();
    } catch (error) {
      console.error("Error saving product:", error);
      Swal.fire({
        icon: "error",
        title: t("Products.modalAdd.save.error"),
        text: error.message,
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } finally {
      setLoading(false);
    }
  };

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      const dataImage = new FormData();
      dataImage.append("upload", file, `${Date.now()}-${file.name}`);

      const response = await axios.post(
        "https://octopus-app-i4ylg.ondigitalocean.app/upload",
        dataImage,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (response.data.url) {
        file.url = response.data.url;
        onSuccess(response.data);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      onError(error);
    }
  };

  // Helper function to reset the form
  const resetForm = () => {
    setData({
      name: "",
      image: "",
      review: "",
      price: "",
      oldPrice: "",
      comment: "",
      qty: 0,
      googleSheetP: "",
      googleSheetPActive: false,
      visits: 0,
      category_id: t("Products.modalAdd.form.category.allProducts"),
      short: "",
      delevery: false,
      upsell: false,
      sku: "",
      show: "1",
      options: [
        {
          title: "",
          color: "",
          option1: "",
          option2: "",
          option3: "",
          option4: "",
        },
      ],
      offers: [
        { title: "", qty: 0, price: 0 },
        { title: "", qty: 0, price: 0 },
        { title: "", qty: 0, price: 0 },
        { title: "", qty: 0, price: 0 },
      ],
      discount: {
        freeDelivery: false,
        activeStay: false,
        discountDelivery: 0,
        discountTotal: 0,
        seconds: 0,
      },
      gallery: [],
      description: [],
      textEditor: "<p><br></p>",
      show: "1",
      timeStamp: serverTimestamp(),
      botButton: "",
      botDescription: "",
      botPhone: "",
      deliverySociety: "",
      adsIds: [],
    });
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [isPreviewVisible, setIsPreviewVisible] = useState(false);

  const handlePreview = async (file) => {
    let preview = file.url || file.preview;

    // If the preview doesn't exist, generate the base64 image
    if (!preview) {
      preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(preview);
    setIsPreviewVisible(true);
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const handleDelete = (uid) => {
    const newFileList = fileList.filter((file) => file.uid !== uid);
    setFileList(newFileList);
  };

  const handleDeleteImage = (imageUrl) => {
    const updatedGallery = data.gallery.filter((image) => image !== imageUrl);
    setData({
      ...data,
      gallery: updatedGallery,
    });
  };

  const closePreview = () => {
    setIsPreviewVisible(false);
    setPreviewImage("");
  };

  const uploadButton = (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#a070b9"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
        className="lucide lucide-image-up mx-auto"
      >
        <path d="M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21" />
        <path d="m14 19.5 3-3 3 3" />
        <path d="M17 22v-5.5" />
        <circle cx="9" cy="9" r="2" />
      </svg>
      <div className="text-[#a070b9] " style={{ marginTop: 8 }}>
        {store.theme === 2
          ? t("Products.modalAdd.uploadButton")
          : t("Products.modalAdd.uploadButtonImage")}
      </div>
    </div>
  );

  const addNewSizeColor = (index, index2, choice, price, quantity) => {
    const updatedOptions = [...data.options];

    const validQuantity = quantity ? parseInt(quantity, 10) : 1; // Default to 1 if empty
    const validPrice =
      price !== undefined && price !== null && price !== ""
        ? parseFloat(price)
        : null;

    // Construct the new size object
    const newSizeObject = {
      choice: normalizeSubOptionChoice(choice, store?.currencySymbol),
      quantity: validQuantity,
    };

    // Only add price if priceEnabled is true and valid
    if (updatedOptions[index].priceEnabled && validPrice !== null) {
      newSizeObject.price = validPrice;
    }

    // Ensure the sizeColor array exists before pushing
    if (!updatedOptions[index].colorOption[index2].sizeColor) {
      updatedOptions[index].colorOption[index2].sizeColor = [];
    }

    // Add the new size object to the array
    updatedOptions[index].colorOption[index2].sizeColor.push(newSizeObject);

    // Update the state with the new data
    setData({ ...data, options: updatedOptions });
  };

  const [sizeValues, setSizeValues] = useState({});
  const [priceValues, setPriceValues] = useState({});
  const [quantityValues, setQuantityValues] = useState({});

  const handleAddSizeColor = (index, index2, size, price, quantity) => {
    if (!size || !size.trim()) return;

    addNewSizeColor(index, index2, size, price || 0, quantity || 0);

    // نفرغ غير inputs لي يخصّو
    setSizeValues((prev) => ({
      ...prev,
      [`${index}-${index2}`]: "",
    }));

    setPriceValues((prev) => ({
      ...prev,
      [`${index}-${index2}`]: "",
    }));

    setQuantityValues((prev) => ({
      ...prev,
      [`${index}-${index2}`]: "",
    }));
  };

  const updateFieldChanged = (index, index2, e, type, color) => {
    let newArr = data.options.map((item, i) => {
      if (index == i) {
        if (type === "update") {
          let newArr2 = item.colorOption.map((item2, i) => {
            if (index2 == i) {
              if (color === 1) {
                return { ...item2, color: e.target.value };
              } else {
                return { ...item2, option: e.target.value };
              }
            } else {
              return item2;
            }
          });
          return { ...item, colorOption: newArr2 };
        } else {
          return {
            ...item,
            colorOption: [
              ...item.colorOption,
              {
                option: "",
                color: "",
                skuEnabled: false,
                sku: "",
              },
            ],
          };
        }
      } else {
        return item;
      }
    });
    setData({ ...data, options: newArr });
  };

  const updateFieldChanged3 = (index, name, e) => {
    let newArr = data.options.map((item, i) => {
      if (index == i) {
        return { ...item, [name]: e.target.value };
      } else {
        return item;
      }
    });
    setData({ ...data, options: newArr });
  };

  const handleRemoveItem = (idx) => {
    const temp = [...data.options];
    temp.splice(idx, 1);
    setData({ ...data, options: temp });
  };

  const handleRemoveItem2 = (idx, idx2) => {
    const temp = [...data.options];
    temp[idx].colorOption.splice(idx2, 1);
    setData({ ...data, options: temp });

    const key = `${idx}-${idx2}`;

    // 🔥 تنظيف القيم المؤقتة (UI فقط)
    setSizeValues((prev) => {
      const copy = { ...prev };
      delete copy[key];
      return copy;
    });

    setPriceValues((prev) => {
      const copy = { ...prev };
      delete copy[key];
      return copy;
    });

    setQuantityValues((prev) => {
      const copy = { ...prev };
      delete copy[key];
      return copy;
    });
  };

  const updateFieldChanged2 = (index, name, value) => {
    let newArr = data.offers.map((item, i) => {
      if (index === i) {
        return { ...item, [name]: value };
      } else {
        return item;
      }
    });
    setData({ ...data, offers: newArr });
  };
  const [isModalVisible, setModalVisible] = useState(false);
  const [isModalVisibleSound, setModalVisibleSound] = useState(false);

  const openModal = () => {
    setModalVisible(true);
  };

  const updateDiscountField = (field, value) => {
    setData((prevData) => ({
      ...prevData,
      discount: {
        ...prevData.discount,
        [field]: value,
      },
    }));
  };
  const [activeTab, setActiveTab] = useState("tab1");
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedFromGallery, setDraggedFromGallery] = useState(false);

  // دالة إعادة الترتيب
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  // دوال السحب والإفلات للـ Gallery Images
  const handleGalleryDragStart = (e, index) => {
    setDraggedItem(index);
    setDraggedFromGallery(true);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleGalleryDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleGalleryDrop = (e, dropIndex) => {
    e.preventDefault();
    if (draggedItem !== null && draggedFromGallery) {
      const newGallery = reorder(data.gallery, draggedItem, dropIndex);
      setData({ ...data, gallery: newGallery });
    }
    setDraggedItem(null);
    setDraggedFromGallery(false);
  };

  // دوال السحب والإفلات للـ Uploaded Files
  const handleFileDragStart = (e, file) => {
    // لا تسمح بالسحب إذا كانت الصورة لا تزال قيد التحميل
    if (file.status === "uploading") {
      e.preventDefault();
      return;
    }
    const index = fileList.findIndex((f) => f.uid === file.uid);
    setDraggedItem(index);
    setDraggedFromGallery(false);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleFileDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleFileDrop = (e, file) => {
    e.preventDefault();
    if (draggedItem !== null && !draggedFromGallery) {
      const dropIndex = fileList.findIndex((f) => f.uid === file.uid);
      const newFileList = reorder(fileList, draggedItem, dropIndex);
      setFileList(newFileList);
    }
    setDraggedItem(null);
    setDraggedFromGallery(false);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    setDraggedFromGallery(false);
  };

  //badreddine

  const isVideo = (url) => {
    return /\.(mp4|webm|ogg|mov)$/i.test(url);
  };

  const [showImageGallery, setShowImageGallery] = useState(false);
  const [currentColorOptionIndex, setCurrentColorOptionIndex] = useState({
    index: null,
    index2: null,
  });

  const openImageGalleryForColor = (index, index2) => {
    setCurrentColorOptionIndex({ index, index2 });
    setShowImageGallery(true);
  };

  const handleSelectImageFromGallery = (imageUrl) => {
    const { index, index2 } = currentColorOptionIndex;
    const updatedOptions = [...data.options];

    updatedOptions[index].colorOption[index2].imageUrl = imageUrl;

    setData({ ...data, options: updatedOptions });
    setShowImageGallery(false);
  };

  const [skuEditor, setSkuEditor] = useState({
    scope: null,
    index: null,
    index2: null,
  });
  const [skuDrafts, setSkuDrafts] = useState({});

  const saveSkuEditor = (scope, index, index2) => {
    if (scope === "color") {
      const key = `color-${index}-${index2}`;
      const updatedOptions = [...data.options];
      updatedOptions[index].colorOption[index2].sku = skuDrafts[key] || "";
      setData({ ...data, options: updatedOptions });
    }

    setSkuEditor({ scope: null, index: null, index2: null });
  };

  return (
    <>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        className="w-100"
        style={{
          zIndex: 999,
        }}
        dialogClassName="custom-modal"
      >
        <Form className="">
          <Modal.Header className="text-white bg-[#a070b9] !w-full">
            <Modal.Title
              id="example-modal-sizes-title-lg"
              className="flex items-center justify-between w-full"
            >
              <span>{t("Products.modalAdd.productInfo")}</span>

              {/* زر تكرار المنتج */}
              {data.id && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip>{t("Products.modalAdd.duplicate")}</Tooltip>
                  }
                >
                  <Button
                    variant="outline-light"
                    size="sm"
                    onClick={handleDuplicateProduct}
                    disabled={duplicateLoading}
                    className="ms-2 d-flex align-items-center gap-1"
                  >
                    {duplicateLoading ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <CopyOutlined />
                    )}
                    <span className="d-none d-md-inline">
                      {t("Products.modalAdd.duplicate2")}
                    </span>
                  </Button>
                </OverlayTrigger>
              )}
            </Modal.Title>
          </Modal.Header>
          <div className="border border-teal-300 rounded-md overflow-hidden sm:zoom-80 lg:zoom-100">
            {/* أزرار التابات */}
            {/* زر بيانات المنتج */}
            {(!digitalStore.isActiveDigitalProducts ||
              data.type !== "digitalProducts") && (
              <>
                <div className="flex m-3 rounded-md border-n">
                  <button
                    type="button"
                    className={`flex-1 p-3  font-semibold flex justify-center items-center gap-2  ${
                      activeTab === "tab1"
                        ? "bg-[#a070b9] text-white"
                        : "text-[#5a2b73] "
                    }`}
                    onClick={() => setActiveTab("tab1")}
                  >
                    <i className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke={activeTab === "tab1" ? "#fff" : "#5a2b73"}
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className={
                          activeTab === "tab1"
                            ? "bg-[#a070b9] text-white"
                            : "text-[#5a2b73]"
                        }
                      >
                        {" "}
                        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />{" "}
                        <path d="M14 2v4a2 2 0 0 0 2 2h4" />{" "}
                        <path d="M10 9H8" /> <path d="M16 13H8" />{" "}
                        <path d="M16 17H8" />{" "}
                      </svg>
                    </i>
                    {t("Products.modalAdd.information")}{" "}
                  </button>
                  <>
                    <a
                      className={`flex-1 p-3  font-semibold flex justify-center items-center gap-2  ${
                        activeTab === "tab2"
                          ? "bg-[#a070b9] text-white"
                          : "text-[#5a2b73]"
                      }`}
                      onClick={() => setActiveTab("tab2")}
                    >
                      <i className="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke={activeTab === "tab2" ? "#fff" : "#5a2b73"}
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className={
                            activeTab === "tab2"
                              ? "bg-[#a070b9] text-white"
                              : "text-[#5a2b73]"
                          }
                        >
                          {" "}
                          <path d="M3 12h.01" /> <path d="M3 18h.01" />{" "}
                          <path d="M3 6h.01" /> <path d="M8 12h13" />{" "}
                          <path d="M8 18h13" /> <path d="M8 6h13" />{" "}
                        </svg>
                      </i>
                      {t("Products.modalAdd.variants")}{" "}
                    </a>
                    <a
                      className={`flex-1 p-3  font-semibold flex justify-center items-center gap-2  ${
                        activeTab === "tab3"
                          ? "bg-[#a070b9] text-white"
                          : "text-[#5a2b73]"
                      }`}
                      onClick={() => setActiveTab("tab3")}
                    >
                      <i className="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke={activeTab === "tab3" ? "#fff" : "#5a2b73"}
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className={
                            activeTab === "tab3"
                              ? "bg-[#a070b9] text-white"
                              : "text-[#5a2b73]"
                          }
                        >
                          <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
                          <path d="M15 18H9" />
                          <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
                          <circle cx="17" cy="18" r="2" />
                          <circle cx="7" cy="18" r="2" />
                        </svg>
                      </i>
                      {t("Products.modalAdd.delivery")}{" "}
                    </a>
                    {store?.foorchat?.enabled === true && (
                      <a
                        className={`flex-1 p-3 font-semibold flex justify-center items-center gap-2 ${
                          activeTab === "tab5"
                            ? "bg-[#a070b9] text-white"
                            : "text-[#5a2b73]"
                        }`}
                        onClick={() => setActiveTab("tab5")}
                      >
                        <i>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke={activeTab === "tab5" ? "#fff" : "#5a2b73"}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M12 8V4H8" />
                            <rect width="16" height="12" x="4" y="8" rx="2" />
                            <path d="M2 14h2" />
                            <path d="M20 14h2" />
                            <path d="M15 13v2" />
                            <path d="M9 13v2" />
                          </svg>
                        </i>
                        {t("Products.modalAdd.bot")}{" "}
                      </a>
                    )}
                  </>
                </div>
              </>
            )}
            {digitalStore.isActiveDigitalProducts &&
              data.type === "digitalProducts" && (
                <>
                  <>
                    <div className="flex m-3 rounded-md border-n ">
                      <a
                        className={`flex-1 p-3  font-semibold flex justify-center items-center gap-2  ${
                          activeTab === "tab1"
                            ? "bg-[#a070b9] text-white"
                            : "text-[#5a2b73] "
                        }`}
                        onClick={() => setActiveTab("tab1")}
                      >
                        <i className="">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke={activeTab === "tab1" ? "#fff" : "#5a2b73"}
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className={
                              activeTab === "tab1"
                                ? "bg-[#a070b9] text-white"
                                : "text-[#5a2b73]"
                            }
                          >
                            {" "}
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />{" "}
                            <path d="M14 2v4a2 2 0 0 0 2 2h4" />{" "}
                            <path d="M10 9H8" /> <path d="M16 13H8" />{" "}
                            <path d="M16 17H8" />{" "}
                          </svg>
                        </i>
                        {t("Products.modalAdd.information")}
                      </a>
                      <>
                        <a
                          className={`flex-1 p-3  font-semibold flex justify-center items-center gap-2  ${
                            activeTab === "tab4"
                              ? "bg-[#a070b9] text-white"
                              : "text-[#5a2b73]"
                          }`}
                          onClick={() => setActiveTab("tab4")}
                        >
                          <i className="">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke={activeTab === "tab4" ? "#fff" : "#5a2b73"}
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              className={
                                activeTab === "tab4"
                                  ? "bg-[#a070b9] text-white"
                                  : "text-[#5a2b73]"
                              }
                            >
                              {" "}
                              <path d="M3 12h.01" /> <path d="M3 18h.01" />{" "}
                              <path d="M3 6h.01" /> <path d="M8 12h13" />{" "}
                              <path d="M8 18h13" /> <path d="M8 6h13" />{" "}
                            </svg>
                          </i>
                          {t("Products.modalAdd.digitalContent")}
                        </a>
                      </>
                    </div>
                  </>
                </>
              )}

            <div className="p-4 pt-0">
              {activeTab === "tab1" && (
                <div>
                  <div className="flex flex-col items-center gap-4">
                    {/* <input
                    type="file"
                    multiple
                    onChange={(e) => handleImageUpload(e.target.files)}
                    className="hidden"
                    id="file-input-gallery"
                  />

                  {!images.length && (
                    <div
                      className="w-full h-36 flex flex-col items-center justify-center border-2 border-dashed border-[#a070b9] cursor-pointer max-w-[400px] mx-auto"
                      onClick={() =>
                        document.getElementById("file-input-gallery").click()
                      }
                    >
                      <i className="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#a070b9"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-image-up"
                        >
                          <path d="M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21" />
                          <path d="m14 19.5 3-3 3 3" />
                          <path d="M17 22v-5.5" />
                          <circle cx="9" cy="9" r="2" />
                        </svg>
                      </i>
                      <div className="text-xs text-[#a070b9] mt-1">
                        إضغط هنا لرفع الصورة
                      </div>
                    </div>
                  )} */}
                  </div>

                  {/* <div className="w-full h-[200px] flex items-center">
                  <input
                    type="file"
                    multiple
                    onChange={(e) => handleImageUpload(e.target.files)}
                    className="hidden"
                    id="file-input-gallery"
                  />

                  {!images.length && !loading && (
                    <div
                      className="w-full h-[100%] mb-4 flex flex-col items-center justify-center border-2 border-dashed border-[#a070b9] cursor-pointer mx-auto"
                      onClick={() =>
                        document.getElementById("file-input-gallery").click()
                      }
                    >
                      <i className="">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#a070b9"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-image-up"
                        >
                          <path d="M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21" />
                          <path d="m14 19.5 3-3 3 3" />
                          <path d="M17 22v-5.5" />
                          <circle cx="9" cy="9" r="2" />
                        </svg>
                      </i>
                      <div className="text-xs text-[#a070b9] mt-1">
                        إضغط هنا لرفع الصورة
                      </div>
                    </div>
                  )}

                  <div className="w-full h-full grid grid-cols-3 gap-2">
                    {loading ? (
                      <div className="col-span-3 flex justify-center items-center">
                        <div className="card rounded-full w-36 h-36 relative overflow-hidden flex items-center justify-center border-2 border-[#a070b9]">
                          <CircularProgress size={40} />
                        </div>
                      </div>
                    ) : (
                      images.map((img, index) => (
                        <div
                          key={index}
                          className="flex flex-col items-center justify-center gap-1"
                        >
                          <div className="card rounded-full w-36 h-36 relative overflow-hidden border-2 border-[#a070b9]">
                            <Image
                              movable={true}
                              preview={true}
                              width={144}
                              height={144}
                              style={{ objectFit: "cover" }}
                              src={img}
                              alt={`Gallery Image ${index + 1}`}
                            />
                          </div>
                          <div className="flex items-center gap-1">
                            <Form.Check
                              inline
                              name="group1"
                              type={"checkbox"}
                              className="mx-2"
                              checked={data.mainImage === img}
                              onChange={() =>
                                setData({ ...data, mainImage: img })
                              }
                            />
                            <p className="text-sm">الصورة الاساسية</p>
                          </div>
                        </div>
                      ))
                    )}
                  </div>

                  {images.length > 0 && (
                    <div
                      className="col-4 col-sm-2 mt-2 cursor-pointer p-1"
                      onClick={() =>
                        document.getElementById("file-input-gallery").click()
                      }
                    >
                      <div className="rounded h-20 w-20 border-2 border-dashed border-gray-300 flex flex-col items-center justify-center">
                        <i className="">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#a070b9"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-image-up"
                          >
                            <path d="M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21" />
                            <path d="m14 19.5 3-3 3 3" />
                            <path d="M17 22v-5.5" />
                            <circle cx="9" cy="9" r="2" />
                          </svg>
                        </i>
                        <div className="text-xs text-[#a070b9] mt-1">
                          رفع صورة
                        </div>
                      </div>
                    </div>
                  )}
                </div> */}

                  <div className="mb-[64px] flex flex-row gap-4">
                    <div className="gallery-preview flex flex-wrap gap-4 mb-4 pt-[14px]">
                      {data.gallery && data.gallery.length > 0
                        ? data.gallery.map((mediaUrl, index) => (
                            <div
                              key={index}
                              draggable
                              onDragStart={(e) =>
                                handleGalleryDragStart(e, index)
                              }
                              onDragOver={(e) =>
                                handleGalleryDragOver(e, index)
                              }
                              onDrop={(e) => handleGalleryDrop(e, index)}
                              onDragEnd={handleDragEnd}
                              className="relative flex flex-col items-center cursor-move"
                              style={{
                                opacity:
                                  draggedItem === index && draggedFromGallery
                                    ? 0.5
                                    : 1,
                                transition: "opacity 0.2s",
                              }}
                            >
                              {isVideo(mediaUrl) ? (
                                <video
                                  src={mediaUrl}
                                  autoPlay
                                  muted
                                  loop
                                  playsInline
                                  controls={false}
                                  className="w-full h-full object-cover rounded-lg mb-2 pointer-events-none"
                                  draggable={false}
                                />
                              ) : (
                                <img
                                  src={mediaUrl}
                                  alt={t("ui.galleryMedia", { value0: (index + 1) })}
                                  className="w-full h-full object-cover rounded-lg mb-2"
                                  draggable={false}
                                />
                              )}

                              <div
                                className="absolute top-0 right-0 p-1 bg-white/80 rounded-full cursor-pointer shadow-md hover:bg-gray-100 z-10"
                                onClick={() => handleDeleteImage(mediaUrl)}
                              >
                                <DeleteOutlined
                                  style={{ color: "red", fontSize: "20px" }}
                                />
                              </div>

                              {!isVideo(mediaUrl) && (
                                <div className="flex items-center gap-1 justify-center mt-2">
                                  <Form.Check
                                    inline
                                    name="mainImage"
                                    type="radio"
                                    className="mx-2"
                                    checked={data.image === mediaUrl}
                                    onChange={() =>
                                      setData({ ...data, image: mediaUrl })
                                    }
                                  />
                                  <p className="text-sm">
                                    {t("Products.modalAdd.principalePhoto")}
                                  </p>
                                </div>
                              )}
                            </div>
                          ))
                        : null}
                    </div>

                    <div className="pictureProduct">
                      {/* File upload section */}
                      <Upload
                        customRequest={customRequest}
                        listType="picture-card"
                        fileList={fileList}
                        onChange={handleChange}
                        onPreview={handlePreview}
                        itemRender={(originNode, file) => (
                          <div
                            draggable
                            onDragStart={(e) => handleFileDragStart(e, file)}
                            onDragOver={handleFileDragOver}
                            onDrop={(e) => handleFileDrop(e, file)}
                            onDragEnd={handleDragEnd}
                            className={`relative h-full flex flex-col items-center cursor-move ${
                              file.status === "done" ? "mb-8" : ""
                            }`}
                            style={{
                              opacity:
                                draggedItem ===
                                  fileList.findIndex(
                                    (f) => f.uid === file.uid,
                                  ) && !draggedFromGallery
                                  ? 0.5
                                  : 1,
                              transition: "opacity 0.2s",
                            }}
                          >
                            <div
                              className="absolute top-0 right-0 p-1 bg-white/80 rounded-full cursor-pointer shadow-md hover:bg-gray-100 z-10"
                              onClick={() => handleDelete(file.uid)}
                            >
                              <DeleteOutlined
                                style={{ color: "red", fontSize: "20px" }}
                              />
                            </div>
                            {originNode}
                            <div className="flex items-center gap-1 justify-center mt-2">
                              <Form.Check
                                inline
                                name="mainImage"
                                type="radio"
                                className="mx-2"
                                checked={
                                  data.image === (file.url || file.preview)
                                }
                                onChange={() =>
                                  setData({
                                    ...data,
                                    image: file.url || file.preview,
                                  })
                                }
                              />
                              <p className="text-sm">
                                {t("Products.modalAdd.principalePhoto")}
                              </p>
                            </div>
                          </div>
                        )}
                      >
                        {fileList.length >= 8 ? null : uploadButton}
                      </Upload>

                      {fileList.map((file) =>
                        file.status === "uploading" ? (
                          <div
                            key={file.uid}
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              zIndex: 10,
                            }}
                          >
                            <Progress
                              type="circle"
                              percent={file.percent}
                              size="small"
                            />
                          </div>
                        ) : null,
                      )}
                    </div>
                  </div>
                  {/* Preview Modal */}
                  {isPreviewVisible && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          maxWidth: "90%",
                          maxHeight: "50%",
                        }}
                      >
                        <button
                          onClick={closePreview}
                          style={{
                            position: "absolute",
                            top: "-20px",
                            right: "-20px",
                            background: "red",
                            color: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            fontSize: "16px",
                            cursor: "pointer",
                            zIndex: 1001,
                          }}
                        >
                          <CloseOutlined />
                        </button>
                        <img
                          alt={t("Products.Table.headers.preview")}
                          src={previewImage}
                          style={{
                            width: "400px",
                            height: "400px",
                            objectFit: "fill",
                            borderRadius: "5px",
                          }}
                        />
                      </div>
                    </div>
                  )}

                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                    <div>
                      <label className="text-[#444] text-[13px] font-medium mb-1">
                        {t("Products.modalAdd.form.name.label")}{" "}
                      </label>
                      <div className="relative mb-6">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#d5d5d5"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-package"
                          >
                            <path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z" />
                            <path d="M12 22V12" />
                            <polyline points="3.29 7 12 12 20.71 7" />
                            <path d="m7.5 4.27 9 5.15" />
                          </svg>
                        </div>
                        <input
                          type="text"
                          value={data.name}
                          onChange={(e) =>
                            setData({ ...data, name: e.target.value })
                          }
                          className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg   block w-full py-2 pr-10    "
                          placeholder={t(
                            "Products.modalAdd.form.name.placeholder",
                          )}
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label className="text-[#444] text-[13px] font-medium mb-1">
                        {t("Products.modalAdd.form.category.label")}{" "}
                      </label>
                      <div className="relative mb-6">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#d5d5d5"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-layout-grid"
                          >
                            <rect width="7" height="7" x="3" y="3" rx="1" />
                            <rect width="7" height="7" x="14" y="3" rx="1" />
                            <rect width="7" height="7" x="14" y="14" rx="1" />
                            <rect width="7" height="7" x="3" y="14" rx="1" />
                          </svg>
                        </div>
                        <div className="mb-3 col-12 sm:col-3">
                          <select
                            aria-label={t(
                              "Products.modalAdd.form.category.label",
                            )}
                            value={data.category_id}
                            required
                            onChange={(e) =>
                              setData({ ...data, category_id: e.target.value })
                            }
                            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 pr-10"
                          >
                            {categories
                              .filter((category) => !!category)
                              .map((category, index) => (
                                <option key={index} value={category}>
                                  {category}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="text-[#444] text-[13px] font-medium mb-1">
                        {t("Products.modalAdd.form.sku.label")}
                      </label>
                      <div className="relative mb-6">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#d5d5d5"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-layers"
                          >
                            <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z" />
                            <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" />
                            <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" />
                          </svg>
                        </div>
                        <input
                          type="text"
                          value={data.sku}
                          onChange={(e) =>
                            setData({ ...data, sku: e.target.value })
                          }
                          className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg   block w-full py-2 pr-10    "
                          placeholder={t(
                            "Products.modalAdd.form.sku.placeholder",
                          )}
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label className="text-[#444] text-[13px] font-medium mb-1">
                        {t("Products.modalAdd.form.url.label")}{" "}
                      </label>
                      <div className="relative mb-6">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#d5d5d5"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-unlink"
                          >
                            <path d="m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71" />
                            <path d="m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71" />
                            <line x1="8" x2="8" y1="2" y2="5" />
                            <line x1="2" x2="5" y1="8" y2="8" />
                            <line x1="16" x2="16" y1="19" y2="22" />
                            <line x1="19" x2="22" y1="16" y2="16" />
                          </svg>
                        </div>
                        <input
                          type="text"
                          value={data.url}
                          onChange={(e) =>
                            setData({
                              ...data,
                              url: e.target.value.replace(/\s+/g, ""),
                            })
                          }
                          required
                          className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg   block w-full py-2 pr-10    "
                          placeholder={t(
                            "Products.modalAdd.form.url.placeholder",
                          )}
                        />
                      </div>
                    </div>

                    {/*------------------------------------------------------------------------------------------------------------------*/}

                    <div className="">
                      <label className="text-[#444] text-[13px] font-medium mb-1 block">
                        {t("Products.modalAdd.form.price.label")}{" "}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#d5d5d5"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-badge-percent"
                          >
                            <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                            <path d="m15 9-6 6" />
                            <path d="M9 9h.01" />
                            <path d="M15 15h.01" />
                          </svg>
                        </div>
                        <input
                          type="text"
                          value={data.price}
                          onChange={(e) =>
                            setData({ ...data, price: e.target.value })
                          }
                          required
                          className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 pr-10"
                          placeholder={t(
                            "Products.modalAdd.form.price.placeholder",
                          )}
                        />
                      </div>
                    </div>
                    <div className="">
                      <label className="text-[#444] text-[13px] font-medium mb-1 block">
                        {t("Products.modalAdd.form.oldPrice.label")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#d5d5d5"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-coins"
                          >
                            <circle cx="8" cy="8" r="6" />
                            <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
                            <path d="M7 6h1v4" />
                            <path d="m16.71 13.88.7.71-2.82 2.82" />
                          </svg>
                        </div>
                        <input
                          type="text"
                          value={data.oldPrice}
                          onChange={(e) =>
                            setData({ ...data, oldPrice: e.target.value })
                          }
                          required
                          className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 pr-10"
                          placeholder={t(
                            "Products.modalAdd.form.oldPrice.placeholder",
                          )}
                        />
                      </div>
                    </div>
                    <div className="">
                      <label className="text-[#444] text-[13px] font-medium mb-1 block">
                        {t("Products.modalAdd.form.profitMargin.label")}
                      </label>
                      <div className="relative">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#d5d5d5"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-coins"
                          >
                            <circle cx="8" cy="8" r="6" />
                            <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
                            <path d="M7 6h1v4" />
                            <path d="m16.71 13.88.7.71-2.82 2.82" />
                          </svg>
                        </div>
                        <input
                          type="text"
                          value={data.profitMargin}
                          onChange={(e) =>
                            setData({ ...data, profitMargin: e.target.value })
                          }
                          required
                          className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 pr-10"
                          placeholder={t(
                            "Products.modalAdd.form.profitMargin.placeholder",
                          )}
                        />
                      </div>
                    </div>

                    <div>
                      <label className="text-[#444] text-[13px] font-medium mb-1 block">
                        {t("Products.modalAdd.form.comment.label")}
                      </label>
                      <div className="relative mb-6">
                        <div className="relative">
                          <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#d5d5d5"
                              stroke-width="1.75"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              className="lucide lucide-coins"
                            >
                              <circle cx="8" cy="8" r="6" />
                              <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
                              <path d="M7 6h1v4" />
                              <path d="m16.71 13.88.7.71-2.82 2.82" />
                            </svg>
                          </div>
                          <input
                            type="text"
                            value={data.comment}
                            onChange={(e) =>
                              setData({ ...data, comment: e.target.value })
                            }
                            required
                            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 pr-10"
                            placeholder={t(
                              "Products.modalAdd.form.comment.placeholder",
                            )}
                          />
                        </div>{" "}
                      </div>
                    </div>
                    {store?.sawa9lyToken && (
                      <div>
                        <label className="text-[#444] text-[13px] font-medium mb-1 block">
                          {t("Products.modalAdd.form.sawa9lyId.label")}
                        </label>
                        <div className="relative mb-6">
                          <div className="relative">
                            <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#d5d5d5"
                                stroke-width="1.75"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              >
                                <path d="m11 17 2 2a1 1 0 1 0 3-3" />
                                <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
                                <path d="m21 3 1 11h-2" />
                                <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
                                <path d="M3 4h8" />
                              </svg>
                            </div>
                            <input
                              type="text"
                              value={data.sawa9lyId}
                              onChange={(e) =>
                                setData({ ...data, sawa9lyId: e.target.value })
                              }
                              required
                              className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 pr-10"
                              placeholder={t(
                                "Products.modalAdd.form.sawa9lyId.placeholder",
                              )}
                            />
                          </div>{" "}
                        </div>
                      </div>
                    )}
                    {(!digitalStore.isActiveDigitalProducts ||
                      data.type === "classic") && (
                      <div>
                        <label className="text-[#444] text-[13px] font-medium mb-1 block">
                          {t("Products.modalAdd.form.reviews.label")}
                        </label>
                        <div className="relative mb-6">
                          <div className="relative">
                            <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#d5d5d5"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                className="lucide lucide-star"
                              >
                                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                              </svg>
                            </div>
                            <input
                              type="number"
                              value={data.review}
                              onChange={(e) => {
                                const value = e.target.value;

                                // التحقق من أن القيمة مدخلة بشكل صحيح بين 1 و 5 فقط
                                if (/^[1-5]?$/.test(value)) {
                                  setData({ ...data, review: value });
                                }
                              }}
                              required
                              className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 pr-10"
                              placeholder={t(
                                "Products.modalAdd.form.reviews.placeholder",
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {(!digitalStore.isActiveDigitalProducts ||
                      data.type === "classic") && (
                      <div>
                        <label className="text-[#444] text-[13px] font-medium mb-1 block">
                          {t("Products.modalAdd.form.quantityWholeSale.label")}
                        </label>
                        <div className="relative mb-6">
                          <div className="relative">
                            <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#d5d5d5"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                className="lucide lucide-star"
                              >
                                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                              </svg>
                            </div>
                            <input
                              type="number"
                              value={data.lastQuantity}
                              onChange={(e) => {
                                const value = e.target.value;

                                if (value === "") {
                                  setData({ ...data, lastQuantity: "" });
                                  return;
                                }

                                const num = Number(value);

                                if (num >= 2) {
                                  setData({ ...data, lastQuantity: num });
                                }
                              }}
                              onBlur={() => {
                                if (!data.lastQuantity) {
                                  setData({ ...data, lastQuantity: 1 });
                                }
                              }}
                              min={2}
                              required
                              className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 pr-10"
                              placeholder={t(
                                "Products.modalAdd.form.quantityWholeSale.placeholder",
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="text-[#444] text-[13px] font-medium mb-1 block">
                      {t("Products.modalAdd.form.qty.label")}{" "}
                    </label>
                    <div className="relative mb-6">
                      <div className="relative flex items-center border border-gray-300 rounded-lg px-2 py-1">
                        {/* أيقونة اللانهاية */}

                        {/* أيقونة الساعة */}
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#d5d5d5"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-archive"
                          >
                            <rect width="20" height="5" x="2" y="3" rx="1" />
                            <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" />
                            <path d="M10 12h4" />
                          </svg>
                        </div>

                        {/* حقل الإدخال */}
                        <div className="relative w-full">
                          <input
                            type="number"
                            value={data.qty}
                            onChange={(e) => {
                              if (!isInfinity) {
                                setData({
                                  ...data,
                                  qty: parseInt(e.target.value),
                                });
                              }
                            }}
                            className="bg-white text-gray-900 text-sm rounded-lg block w-full py-2 pr-10"
                            placeholder={
                              isInfinity
                                ? t(
                                    "Products.modalAdd.form.qty.placeholder.infinity",
                                  )
                                : t(
                                    "Products.modalAdd.form.qty.placeholder.default",
                                  )
                            }
                            disabled={isInfinity}
                          />
                          {isInfinity && (
                            <p className="text-red-500 text-xs mt-2">
                              {t("Products.modalAdd.form.qty.warning")}
                            </p>
                          )}
                        </div>

                        <button
                          type="button"
                          onClick={openLimitedValueModal}
                          title={t(
                            "Products.modalAdd.form.limitedValue.modalTitle",
                          )}
                          className="p-2 hover:bg-gray-100 rounded-lg"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#2e2e2e"
                            strokeWidth="1.75"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-bell-dot"
                          >
                            <path d="M10.268 21a2 2 0 0 0 3.464 0" />
                            <path d="M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665" />
                            <circle cx="18" cy="8" r="3" />
                          </svg>
                        </button>

                        <Modal
                          show={isLimitedValueModalOpen}
                          onHide={closeLimitedValueModal}
                          centered
                          contentClassName="custom-modal-content"
                          style={{ zIndex: 99999999 }}
                        >
                          <Modal.Header className="bg-[#faf1ff] border-b-purple-300">
                            <Modal.Title className="text-[#9e68ba] font-bold text-lg">
                              {t(
                                "Products.modalAdd.form.limitedValue.modalTitle",
                              )}
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body className="p-4">
                            <input
                              type="number"
                              id="limitedValue"
                              placeholder={t(
                                "Products.modalAdd.form.limitedValue.inputPlaceholder",
                              )}
                              value={limitedValue}
                              onChange={(e) => {
                                const value = parseInt(e.target.value, 10);
                                if (!isNaN(value) && value >= 0) {
                                  setLimitedValue(value);
                                } else if (e.target.value === "") {
                                  setLimitedValue("");
                                }
                              }}
                              className="border border-gray-300 rounded px-3 py-2 mb-4 w-full focus:outline-none focus:ring-2 focus:ring-purple-400"
                            />
                            <div className="flex justify-end gap-2">
                              <button
                                type="button"
                                onClick={closeLimitedValueModal}
                                className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded transition"
                              >
                                {t(
                                  "Products.modalAdd.form.limitedValue.cancel",
                                )}
                              </button>
                              <button
                                onClick={handleSubmitLimitedValue}
                                className="bg-[#9b59bf] hover:bg-[#814a9f] text-white px-4 py-2 rounded transition"
                              >
                                {t(
                                  "Products.modalAdd.form.limitedValue.submit",
                                )}
                              </button>
                            </div>
                          </Modal.Body>
                        </Modal>

                        <a
                          onClick={openInfinityDialog}
                          className="p-2 hover:bg-gray-100 rounded-lg"
                          title={
                            isInfinity
                              ? t("Products.modalAdd.form.infinity.off")
                              : t("Products.modalAdd.form.infinity.on")
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#2e2e2e"
                            stroke-width="1.75"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-infinity"
                          >
                            <path d="M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z" />
                          </svg>
                        </a>
                        <ConfirmDialog
                          open={isInfinityDialogOpen}
                          onClose={closeInfinityDialog}
                          onConfirm={handleInfinityConfirm}
                          dialogTitle={
                            isInfinity
                              ? t("Products.modalAdd.form.infinity.off")
                              : t("Products.modalAdd.form.infinity.on")
                          }
                          dialogContentText={
                            isInfinity
                              ? t("Products.modalAdd.form.infinity.confirm.off")
                              : t("Products.modalAdd.form.infinity.confirm.on")
                          }
                        />
                      </div>
                    </div>{" "}
                  </div>
                  {/* <div className="d-flex mb-3">
                    <Form.Check
                      inline
                      name="group1"
                      type={"checkbox"}
                      className="mx-2 "
                      checked={data.delevery}
                      onChange={() => {
                        const updatedData = {
                          ...data,
                          delevery: !data.delevery,
                        };
                        setData(updatedData);
                      }}
                    />
                    <p className="">التوصيل مجاني</p>
                  </div> */}
                  {store.Upsell && (
                    <div className="d-flex ">
                      <Form.Check
                        inline
                        name="group1"
                        type={"checkbox"}
                        className="mx-2 "
                        checked={data.upsell}
                        onChange={() => {
                          const updatedData = {
                            ...data,
                            upsell: !data.upsell,
                          };
                          setData(updatedData);
                        }}
                      />
                      <p className="">
                        {t("Products.modalAdd.form.upsellLabel")}
                      </p>
                    </div>
                  )}
                  <br></br>
                  {(!digitalStore.isActiveDigitalProducts ||
                    data.type === "classic") && (
                    <div className="d-flex mb-6">
                      <Form.Check
                        inline
                        name="group1"
                        type={"checkbox"}
                        className="mx-2 "
                        checked={data.stockDelivery}
                        onChange={() => {
                          const updatedData = {
                            ...data,
                            stockDelivery: !data.stockDelivery,
                          };
                          setData(updatedData);
                        }}
                      />
                      <p className="">
                        {t("Products.modalAdd.form.stockDelivery")}
                      </p>
                    </div>
                  )}
                  {!hideProductDescription && (
                    <>
                      <label className="text-[#444] text-[13px] font-medium mb-1 block">
                        {t("Products.modalAdd.form.shortDescriptionLabel")}
                      </label>
                      <div className="relative mb-6">
                        <div className="relative">
                          <Form.Control
                            className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg  outline-none focus:ring-offset-2 focus:ring-purple-400 focus:ring-2"
                            as="textarea"
                            rows={3}
                            value={data.short}
                            onChange={(e) =>
                              setData({ ...data, short: e.target.value })
                            }
                          />
                        </div>
                      </div>
                      <Modal.Body style={{ marginBottom: "56px" }}>
                        <label className="text-[#444] text-[13px] font-medium mb-1 block">
                          {t("Products.modalAdd.form.fullDescriptionLabel")}
                        </label>
                        <QuillEditor
                          className="w-full inline-flex items-center justify-between  text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-purple-400 focus:ring-2"
                          data={data}
                          setData={setData}
                        />
                      </Modal.Body>
                    </>
                  )}
                </div>
              )}

              {activeTab === "tab2" && (
                <div>
                  {/*-----------------------------------------------------------------------------------------------------------------------------------------*/}
                  <div className="border border-gray-300 rounded-lg w-full bg-white flex flex-col gap-2 my-3">
                    {/* Header */}
                    <div className="flex items-center justify-between bg-[#fbf5ff] p-2 rounded-lg border-b border-[#eee] ">
                      <div className="flex items-center gap-2">
                        <span className="text-xl text-red-500 hover:text-red-700 p-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#707070"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-menu"
                          >
                            <line x1="4" x2="20" y1="12" y2="12" />
                            <line x1="4" x2="20" y1="6" y2="6" />
                            <line x1="4" x2="20" y1="18" y2="18" />
                          </svg>
                        </span>
                        <span className="text-gray-700 font-medium">
                          {t("Products.modalAdd.tab2.productOptionsTitle")}{" "}
                        </span>
                      </div>
                      <div className="flex items-center gap-2 ml-2">
                        <div className="row">
                          {/* <button
                            type="button"
                            onClick={() =>
                              setData({
                                ...data,
                                options: [
                                  ...data.options,
                                  {
                                    title: "1",
                                    color: "1",
                                    colorOption: [
                                      {
                                        option: "",
                                        color: "",
                                      },
                                    ],
                                  },
                                ],
                              })
                            }
                            className="flex items-center gap-2 text-white bg-[#00a987] hover:bg-[#02755e] focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-4 py-2 text-center max-w-[182px] mx-auto"
                            style={{ maxWidth: "182px" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#ffffff"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-plus"
                            >
                              <circle cx="12" cy="12" r="10" />
                              <path d="M8 12h8" />
                              <path d="M12 8v8" />
                            </svg>
                            <span>إضافة خيار</span>
                          </button> */}
                          <div className="relative w-fit">
                            <button
                              type="button"
                              onClick={toggleAddOptionDropdown}
                              className="flex items-center gap-2 text-white bg-[#00a987] hover:bg-[#02755e] focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm px-4 py-2 text-center w-fit mx-auto"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-circle-plus"
                              >
                                <circle cx="12" cy="12" r="10" />
                                <path d="M8 12h8" />
                                <path d="M12 8v8" />
                              </svg>
                              <span>
                                {t("Products.modalAdd.tab2.addOptionButton")}
                              </span>
                            </button>

                            {isAddOptionDropdownOpen && (
                              <div className="z-[9999] absolute left-0 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg p-2 w-[200px]">
                                <ul className="w-full">
                                  <li
                                    onClick={addOption1}
                                    className="py-2 px-4 w-full hover:bg-gray-100 cursor-pointer"
                                  >
                                    {t("Products.modalAdd.tab2.addColorOption")}
                                  </li>
                                  <li
                                    onClick={addOption2}
                                    className="py-2 px-4 w-full hover:bg-gray-100 cursor-pointer"
                                  >
                                    {t(
                                      "Products.modalAdd.tab2.addCustomOption",
                                    )}
                                  </li>
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {data.options?.map((option, index) =>
                      option.colorOption ? (
                        <div className=" q1" key={index}>
                          <div className="flex items-center justify-between bg-[#fbf5ff] py-2 pr-2 rounded-lg border-b border-[#eee] mb-3 ">
                            <div className="flex items-center gap-2">
                              <span className="text-xl">
                                {option.color === "1" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-palette inline-block"
                                  >
                                    <circle
                                      cx="13.5"
                                      cy="6.5"
                                      r=".5"
                                      fill="currentColor"
                                    />
                                    <circle
                                      cx="17.5"
                                      cy="10.5"
                                      r=".5"
                                      fill="currentColor"
                                    />
                                    <circle
                                      cx="8.5"
                                      cy="7.5"
                                      r=".5"
                                      fill="currentColor"
                                    />
                                    <circle
                                      cx="6.5"
                                      cy="12.5"
                                      r=".5"
                                      fill="currentColor"
                                    />
                                    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#707070"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-list inline-block"
                                  >
                                    <line x1="8" y1="6" x2="21" y2="6" />
                                    <line x1="8" y1="12" x2="21" y2="12" />
                                    <line x1="8" y1="18" x2="21" y2="18" />
                                    <line x1="3" y1="6" x2="3.01" y2="6" />
                                    <line x1="3" y1="12" x2="3.01" y2="12" />
                                    <line x1="3" y1="18" x2="3.01" y2="18" />
                                  </svg>
                                )}
                              </span>
                              <span className="text-gray-700 font-medium">
                                {option.color === "1"
                                  ? t("Products.modalAdd.tab2.colorOptionTitle")
                                  : t(
                                      "Products.modalAdd.tab2.optionsTitle",
                                    )}{" "}
                              </span>
                            </div>
                            <div className="flex items-center gap-2 ">
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip>
                                    {option.color === "1"
                                      ? t(
                                          "Products.modalAdd.tab2.addColorButton",
                                        )
                                      : t(
                                          "Products.modalAdd.tab2.addOptionButton",
                                        )}
                                  </Tooltip>
                                }
                              >
                                <div className="row">
                                  <button
                                    className="p-2 hover:bg-gray-100 rounded-lg"
                                    type="button"
                                    onClick={() => {
                                      updateFieldChanged(index, 0, "e", "add");
                                    }}
                                  >
                                    <span>
                                      {option.color === "1"
                                        ? t(
                                            "Products.modalAdd.tab2.addColorButton",
                                          )
                                        : t(
                                            "Products.modalAdd.tab2.addOptionButton",
                                          )}
                                    </span>
                                  </button>
                                </div>
                              </OverlayTrigger>
                              <a
                                className="p-2  rounded-lg  "
                                onClick={() => handleRemoveItem(index)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#f55157"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  className="lucide lucide-trash-2"
                                >
                                  <path d="M3 6h18" />
                                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                                  <line x1="10" x2="10" y1="11" y2="17" />
                                  <line x1="14" x2="14" y1="11" y2="17" />
                                </svg>{" "}
                              </a>
                            </div>
                          </div>
                          <div className="relative flex items-center m-3">
                            <input
                              placeholder={
                                option.color === "1"
                                  ? t(
                                      "Products.modalAdd.tab2.colorTitlePlaceholder",
                                    )
                                  : t(
                                      "Products.modalAdd.tab2.optionTitlePlaceholder",
                                    )
                              }
                              value={option.title}
                              name="title"
                              onChange={(e) =>
                                updateFieldChanged3(index, "title", e)
                              }
                              className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg w-full py-2 pr-10 pl-10"
                            />
                            <div className="absolute inset-y-0 end-0 flex items-center pe-3.5 pointer-events-none">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#d5d5d5"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-layers flex-shrink-0 mr-2"
                              >
                                <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z" />
                                <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12" />
                                <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17" />
                              </svg>
                            </div>
                          </div>
                          {/* الزر الخاص بكل عنصر لتمكين/تعطيل الإعدادات المتقدمة */}
                          <div className="d-flex">
                            <Form.Check
                              inline
                              name={`group${index}`} // استخدم index للتأكد من أن كل زر يتعامل مع حالة خاصة به
                              type={"checkbox"}
                              id={`advancedOptions-${index}`}
                              checked={option.advancedOptionsEnabled} // حالة تفعيل الخيارات المتقدمة الخاصة بالعنصر
                              onChange={(e) => {
                                const updatedOptions = [...data.options];
                                updatedOptions[index].advancedOptionsEnabled =
                                  e.target.checked; // تحديث الحالة لهذا العنصر فقط
                                setData({ ...data, options: updatedOptions });
                              }}
                            />
                            <p
                              style={{
                                marginRight: "5px",
                                marginBottom: "5px",
                              }}
                            >
                              {" "}
                              {t(
                                "Products.modalAdd.tab2.enableAdvancedOptions",
                              )}{" "}
                            </p>
                          </div>

                          <div className="d-flex mb-2">
                            <Form.Check
                              inline
                              name={`group${index}`}
                              type={"checkbox"}
                              id={`priceEnabled-${index}`}
                              checked={option.priceEnabled}
                              onChange={(e) => {
                                const updatedOptions = [...data.options];
                                updatedOptions[index].priceEnabled =
                                  e.target.checked;
                                setData({ ...data, options: updatedOptions });
                              }}
                            />
                            <p style={{ marginRight: "5px" }}>
                              {t("Products.modalAdd.tab2.enablePricing")}
                            </p>
                          </div>

                          <div className="d-flex mb-2">
                            <Form.Check
                              inline
                              name={`group${index}`}
                              type={"checkbox"}
                              id={`priceEnabled-${index}`}
                              checked={option.require}
                              onChange={(e) => {
                                const updatedOptions = [...data.options];
                                updatedOptions[index].require =
                                  e.target.checked;
                                setData({ ...data, options: updatedOptions });
                              }}
                            />
                            <p style={{ marginRight: "5px" }}>
                              {t("Products.modalAdd.tab2.require")}
                            </p>
                          </div>
                          {option.require && (
                            <p className="text-sm text-orange-500 mt-1">
                              {t("Products.modalAdd.tab2.requireWarning")}
                            </p>
                          )}

                          <div className="row gap-4 m-2">
                            {option?.colorOption?.map((o, index2) => (
                              <Form.Group
                                className="col-6 col-lg-4 row"
                                key={index2}
                              >
                                <a
                                  className="text-danger bi bi-x-circle-fill relative top-[-10px] left-[-4px]"
                                  onClick={() =>
                                    handleRemoveItem2(index, index2)
                                  }
                                ></a>
                                <div className=" w-52 sm:w-auto  items-center p-3 rounded-xl shadow-sm transition-all duration-200 bg-white dark:!bg-[#181919] border border-purple-100 dark:!border-[#3c3a3d] hover:bg-purple-50 hover:shadow ">
                                  <div className="d-flex mb-2">
                                    <Form.Check
                                      inline
                                      name={`skuEnabled-${index}-${index2}`}
                                      type={"checkbox"}
                                      id={`sku-enabled-${index}-${index2}`}
                                      checked={o.skuEnabled ?? !!o.sku}
                                      onChange={(e) => {
                                        const updatedOptions = [
                                          ...data.options,
                                        ];
                                        updatedOptions[index].colorOption[
                                          index2
                                        ] = {
                                          ...updatedOptions[index].colorOption[
                                            index2
                                          ],
                                          skuEnabled: e.target.checked,
                                          sku: e.target.checked
                                            ? updatedOptions[index].colorOption[
                                                index2
                                              ].sku || ""
                                            : "",
                                        };
                                        setData({
                                          ...data,
                                          options: updatedOptions,
                                        });
                                      }}
                                    />
                                    <p
                                      style={{
                                        marginRight: "5px",
                                        marginBottom: "5px",
                                      }}
                                    >
                                      {t("Products.modalAdd.form.sku.label")}
                                    </p>
                                  </div>
                                  <div className="mb-2">
                                    <div className="d-flex align-items-center">
                                      <Form.Check
                                        inline
                                        name={`subOptionsStock-${index}-${index2}`}
                                        type="checkbox"
                                        className="mx-2"
                                        id={`sub-options-stock-${index}-${index2}`}
                                        checked={Boolean(o.subOptionsStock)}
                                        onChange={(e) => {
                                          const isEnabled = e.target.checked;
                                          const updatedOptions = [
                                            ...data.options,
                                          ];
                                          updatedOptions[index].colorOption[
                                            index2
                                          ] = {
                                            ...updatedOptions[index]
                                              .colorOption[index2],
                                            subOptionsStock: isEnabled,
                                          };
                                          setData({
                                            ...data,
                                            options: updatedOptions,
                                          });

                                          if (isEnabled) {
                                            Swal.fire({
                                              icon: "info",
                                              title: t(
                                                "Products.modalAdd.form.sku.subOptionsStockLabel",
                                              ),
                                              text: t(
                                                "Products.modalAdd.form.sku.subOptionsStockDescription",
                                              ),
                                              confirmButtonText: t(
                                                "Products.modalAdd.okay",
                                              ),
                                              confirmButtonColor:
                                                "rgb(141, 93, 167)",
                                            });
                                          }
                                        }}
                                      />
                                      <label
                                        htmlFor={`sub-options-stock-${index}-${index2}`}
                                        className="text-[#444] text-xs cursor-pointer"
                                      >
                                        {t(
                                          "Products.modalAdd.form.sku.subOptionsStockLabel",
                                        )}
                                      </label>
                                    </div>
                                  </div>
                                  {(o.skuEnabled ?? !!o.sku) && (
                                    <input
                                      type="text"
                                      value={o.sku || ""}
                                      onChange={(e) => {
                                        const updatedOptions = [
                                          ...data.options,
                                        ];
                                        updatedOptions[index].colorOption[
                                          index2
                                        ] = {
                                          ...updatedOptions[index].colorOption[
                                            index2
                                          ],
                                          sku: e.target.value,
                                        };
                                        setData({
                                          ...data,
                                          options: updatedOptions,
                                        });
                                      }}
                                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg w-full py-2 px-3 mb-2"
                                      placeholder={t(
                                        "Products.modalAdd.form.sku.placeholder",
                                      )}
                                    />
                                  )}
                                  {option.color === "0" && (
                                    <Form.Control
                                      placeholder={
                                        option.color === "1"
                                          ? t(
                                              "Products.modalAdd.tab2.colorPlaceholder",
                                            )
                                          : t(
                                              "Products.modalAdd.tab2.optionPlaceholder",
                                            )
                                      }
                                      value={o.option}
                                      onChange={(e) =>
                                        updateFieldChanged(
                                          index,
                                          index2,
                                          e,
                                          "update",
                                          0,
                                        )
                                      }
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "Enter" &&
                                          o.option.trim()
                                        ) {
                                          e.preventDefault();
                                          // Create the object with the desired fields
                                          const newOptionObject = {
                                            option: o.option.trim(),
                                            sku:
                                              (o.skuEnabled ?? !!o.sku)
                                                ? o.sku || ""
                                                : "",
                                            skuEnabled: o.skuEnabled ?? !!o.sku,
                                            subOptionsStock: Boolean(
                                              o.subOptionsStock,
                                            ),
                                            color: o.color || "",
                                          };
                                          const updatedOptions = [
                                            ...data.options,
                                          ];
                                          updatedOptions[index].colorOption[
                                            index2
                                          ] = newOptionObject;
                                          setData({
                                            ...data,
                                            options: updatedOptions,
                                          });
                                          updateFieldChanged(
                                            index,
                                            index2,
                                            "",
                                            "reset",
                                            0,
                                          );
                                        }
                                      }}
                                      className="w-full inline-flex items-center justify-between text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-purple-400 focus:ring-2"
                                    />
                                  )}

                                  {/* عرض الإعدادات المتقدمة إذا كان الخيار مفعلاً */}
                                  {option.advancedOptionsEnabled ? (
                                    <div
                                      className="tag-input"
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "5px",
                                        marginTop: "10px",
                                      }}
                                    >
                                      {o.sizeColor &&
                                        o.sizeColor.map((size, idx) => (
                                          <div
                                            key={idx}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              background: "#e0e0e0",
                                              borderRadius: "20px",
                                              padding: "5px 10px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                margin: "4px",
                                              }}
                                            >
                                              <span
                                                dir="ltr"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "4px",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                <bdi>{size.choice}</bdi>
                                                {size.price > 0 && (
                                                  <>
                                                    <span>-</span>
                                                    <bdi>
                                                      {store?.currencySymbol}
                                                    </bdi>
                                                    <bdi>{size.price}</bdi>
                                                  </>
                                                )}
                                              </span>
                                              <span
                                                dir={i18n.dir()}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "4px",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                <span>
                                                  {t(
                                                    "Products.modalAdd.tab2.quantityPlaceholder",
                                                  )}
                                                  :
                                                </span>
                                                <bdi>{size.quantity}</bdi>
                                              </span>
                                            </div>
                                            <button
                                              type="button"
                                              style={{
                                                marginLeft: "5px",
                                                background: "transparent",
                                                border: "none",
                                                cursor: "pointer",
                                              }}
                                              onClick={() => {
                                                const newSizeColor =
                                                  o.sizeColor.filter(
                                                    (_, sIdx) => sIdx !== idx,
                                                  );
                                                const updatedOptions = [
                                                  ...data.options,
                                                ];
                                                updatedOptions[
                                                  index
                                                ].colorOption[
                                                  index2
                                                ].sizeColor = newSizeColor;
                                                setData({
                                                  ...data,
                                                  options: updatedOptions,
                                                });
                                              }}
                                            >
                                              ×
                                            </button>
                                          </div>
                                        ))}
                                      {/* حقل لإضافة المقاس */}
                                      <Form.Control
                                        type="text"
                                        placeholder={t(
                                          "Products.modalAdd.tab2.addSizePlaceholder",
                                        )}
                                        value={
                                          sizeValues[`${index}-${index2}`] || ""
                                        }
                                        onChange={(e) =>
                                          setSizeValues({
                                            ...sizeValues,
                                            [`${index}-${index2}`]:
                                              e.target.value,
                                          })
                                        }
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "Enter" &&
                                            sizeValues[`${index}-${index2}`]
                                          ) {
                                            e.preventDefault();
                                            handleAddSizeColor(
                                              index,
                                              index2,
                                              sizeValues[`${index}-${index2}`],
                                            );

                                            // نفرغ غير هذا input
                                            setSizeValues({
                                              ...sizeValues,
                                              [`${index}-${index2}`]: "",
                                            });
                                          }
                                        }}
                                      />
                                      {option.priceEnabled && (
                                        <Form.Control
                                          type="number"
                                          placeholder={t(
                                            "Products.modalAdd.tab2.pricePlaceholder",
                                          )}
                                          value={
                                            priceValues[`${index}-${index2}`] ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            setPriceValues({
                                              ...priceValues,
                                              [`${index}-${index2}`]:
                                                e.target.value,
                                            })
                                          }
                                          onKeyDown={(e) => {
                                            if (
                                              e.key === "Enter" &&
                                              sizeValues[`${index}-${index2}`]
                                            ) {
                                              e.preventDefault();
                                              handleAddSizeColor(
                                                index,
                                                index2,
                                                sizeValues[
                                                  `${index}-${index2}`
                                                ],
                                                priceValues[
                                                  `${index}-${index2}`
                                                ],
                                                quantityValues[
                                                  `${index}-${index2}`
                                                ],
                                              );

                                              // نفرغ غير هذا input
                                              setPriceValues({
                                                ...priceValues,
                                                [`${index}-${index2}`]: "",
                                              });
                                            }
                                          }}
                                        />
                                      )}

                                      <Form.Control
                                        type="number"
                                        placeholder={t(
                                          "Products.modalAdd.tab2.quantityPlaceholder",
                                        )}
                                        value={
                                          quantityValues[
                                            `${index}-${index2}`
                                          ] || ""
                                        }
                                        onChange={(e) =>
                                          setQuantityValues({
                                            ...quantityValues,
                                            [`${index}-${index2}`]:
                                              e.target.value,
                                          })
                                        }
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "Enter" &&
                                            sizeValues[`${index}-${index2}`]
                                          ) {
                                            e.preventDefault();
                                            handleAddSizeColor(
                                              index,
                                              index2,
                                              sizeValues[`${index}-${index2}`],
                                              priceValues[`${index}-${index2}`],
                                              quantityValues[
                                                `${index}-${index2}`
                                              ],
                                            );

                                            // نفرغ غير هذا input
                                            setQuantityValues({
                                              ...quantityValues,
                                              [`${index}-${index2}`]: "",
                                            });
                                          }
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    option.priceEnabled && (
                                      // عرض حقل السعر إذا كانت الإعدادات المتقدمة غير مفعلة
                                      <Form.Control
                                        type="number"
                                        placeholder={t(
                                          "Products.modalAdd.tab2.enableAdvancedOptions",
                                        )}
                                        value={
                                          data.options[index].colorOption[
                                            index2
                                          ].price !== undefined
                                            ? data.options[index].colorOption[
                                                index2
                                              ].price
                                            : data.price
                                        }
                                        onChange={(e) => {
                                          const updatedOptions = [
                                            ...data.options,
                                          ];
                                          updatedOptions[index].colorOption[
                                            index2
                                          ].price = e.target.value;
                                          setData({
                                            ...data,
                                            options: updatedOptions,
                                          });
                                        }}
                                        className="w-full inline-flex items-center justify-between text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none focus:ring-offset-2 focus:ring-purple-400 focus:ring-2 mt-2"
                                      />
                                    )
                                  )}

                                  <>
                                    {/* اللون والاسم في صف واحد */}
                                    {option.color === "1" && (
                                      <div className="d-flex gap-2 align-items-center mt-2">
                                        <Form.Control
                                          type="color"
                                          value={o.color}
                                          onChange={(e) =>
                                            updateFieldChanged(
                                              index,
                                              index2,
                                              e,
                                              "update",
                                              1,
                                            )
                                          }
                                          style={{
                                            width: "50px",
                                            height: "40px",
                                            padding: "2px",
                                            border: "2px solid #e0e0e0",
                                            borderRadius: "8px",
                                            cursor: "pointer",
                                          }}
                                        />
                                        <Form.Control
                                          placeholder={t(
                                            "Products.modalAdd.tab2.colorNamePlaceholder",
                                          )}
                                          value={o.option}
                                          onChange={(e) =>
                                            updateFieldChanged(
                                              index,
                                              index2,
                                              e,
                                              "update",
                                              0,
                                            )
                                          }
                                          className="flex-grow-1"
                                          style={{
                                            height: "40px",
                                            border: "1px solid #e0e0e0",
                                            borderRadius: "8px",
                                          }}
                                        />
                                      </div>
                                    )}

                                    {/* أيقونة الصورة الصغيرة */}
                                    {store.theme === 2 && (
                                      <div className="mt-2">
                                        {o.imageUrl ? (
                                          <div
                                            className="d-flex align-items-center gap-2 p-2 border rounded"
                                            style={{
                                              backgroundColor: "#f8f9fa",
                                            }}
                                          >
                                            {/* الصورة كأيقونة صغيرة */}
                                            <div className="position-relative">
                                              <img
                                                src={o.imageUrl}
                                                alt={t(
                                                  "Products.modalAdd.tab2.colorImageAlt",
                                                )}
                                                style={{
                                                  width: "50px",
                                                  height: "50px",
                                                  objectFit: "cover",
                                                  borderRadius: "6px",
                                                  border: "2px solid #a070b9",
                                                }}
                                              />
                                              {/* زر الحذف الصغير */}
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  const updatedOptions = [
                                                    ...data.options,
                                                  ];
                                                  updatedOptions[
                                                    index
                                                  ].colorOption[
                                                    index2
                                                  ].imageUrl = "";
                                                  setData({
                                                    ...data,
                                                    options: updatedOptions,
                                                  });
                                                }}
                                                style={{
                                                  position: "absolute",
                                                  top: "-6px",
                                                  right: "-6px",
                                                  width: "20px",
                                                  height: "20px",
                                                  border: "none",
                                                  borderRadius: "50%",
                                                  backgroundColor: "#dc3545",
                                                  color: "white",
                                                  fontSize: "14px",
                                                  lineHeight: "1",
                                                  cursor: "pointer",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  boxShadow:
                                                    "0 2px 4px rgba(0,0,0,0.2)",
                                                }}
                                              >
                                                ×
                                              </button>
                                            </div>

                                            {/* زر تغيير الصورة */}
                                            <button
                                              type="button"
                                              onClick={() =>
                                                openImageGalleryForColor(
                                                  index,
                                                  index2,
                                                )
                                              }
                                              className="flex-grow-1 hover:text-white"
                                              style={{
                                                padding: "8px 12px",
                                                border: "1px solid #a070b9",
                                                backgroundColor: "white",
                                                color: "#a070b9",
                                                borderRadius: "6px",
                                                fontSize: "13px",
                                                fontWeight: "500",
                                                cursor: "pointer",
                                                transition: "all 0.2s",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: "6px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#a070b9";
                                                e.currentTarget.style.color =
                                                  "white";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.color =
                                                  "#a070b9";
                                              }}
                                            >
                                              {t(
                                                "Products.modalAdd.tab2.changeImage",
                                              )}
                                            </button>
                                          </div>
                                        ) : (
                                          <button
                                            type="button"
                                            onClick={() =>
                                              openImageGalleryForColor(
                                                index,
                                                index2,
                                              )
                                            }
                                            className="w-100"
                                            style={{
                                              padding: "10px",
                                              border: "2px dashed #a070b9",
                                              backgroundColor: "#f8f5fb",
                                              color: "#a070b9",
                                              borderRadius: "8px",
                                              fontSize: "13px",
                                              cursor: "pointer",
                                              transition: "all 0.2s",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              gap: "8px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#f0e8f5";
                                              e.currentTarget.style.borderColor =
                                                "#8d5da7";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#f8f5fb";
                                              e.currentTarget.style.borderColor =
                                                "#a070b9";
                                            }}
                                          >
                                            <i className="bi bi-plus-circle"></i>
                                            {option.color === "1"
                                              ? t(
                                                  "Products.modalAdd.addPicturetoColor",
                                                )
                                              : t(
                                                  "Products.modalAdd.addPicturetoOption",
                                                )}{" "}
                                          </button>
                                        )}
                                      </div>
                                    )}
                                  </>

                                  {/* Modal معرض الصور - خارج loop */}

                                  {showImageGallery && store.theme === 2 && (
                                    <div
                                      style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: "rgba(0,0,0,0.75)",
                                        zIndex: 99999,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backdropFilter: "blur(4px)",
                                      }}
                                      onClick={() => setShowImageGallery(false)}
                                    >
                                      <div
                                        style={{
                                          backgroundColor: "white",
                                          borderRadius: "16px",
                                          maxWidth: "900px",
                                          maxHeight: "85vh",
                                          width: "95%",
                                          boxShadow:
                                            "0 20px 60px rgba(0,0,0,0.3)",
                                          overflow: "hidden",
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        {/* Header */}
                                        <div
                                          style={{
                                            padding: "20px 24px",
                                            borderBottom: "1px solid #e0e0e0",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            backgroundColor: "#fafafa",
                                          }}
                                        >
                                          <div className="d-flex align-items-center gap-2">
                                            <i
                                              className="bi bi-images"
                                              style={{
                                                fontSize: "24px",
                                                color: "#a070b9",
                                              }}
                                            ></i>
                                            <h4
                                              className="m-0"
                                              style={{
                                                fontSize: "18px",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {t(
                                                "Products.modalAdd.tab2.selectFromGallery",
                                              )}
                                            </h4>
                                          </div>
                                          <button
                                            onClick={() =>
                                              setShowImageGallery(false)
                                            }
                                            style={{
                                              border: "none",
                                              background: "#f0f0f0",
                                              cursor: "pointer",
                                              fontSize: "24px",
                                              lineHeight: "1",
                                              color: "#666",
                                              width: "36px",
                                              height: "36px",
                                              borderRadius: "50%",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              transition: "all 0.2s",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#dc3545";
                                              e.currentTarget.style.color =
                                                "white";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#f0f0f0";
                                              e.currentTarget.style.color =
                                                "#666";
                                            }}
                                          >
                                            ×
                                          </button>
                                        </div>

                                        {/* Body - Grid الصور */}
                                        <div
                                          style={{
                                            padding: "20px",
                                            maxHeight: "calc(85vh - 80px)",
                                            overflowY: "auto",
                                          }}
                                        >
                                          {data.gallery &&
                                          data.gallery.length > 0 ? (
                                            <div
                                              style={{
                                                display: "grid",
                                                gridTemplateColumns:
                                                  "repeat(auto-fill, minmax(140px, 1fr))",
                                                gap: "12px",
                                              }}
                                            >
                                              {data.gallery.map((img, idx) => (
                                                <div
                                                  key={idx}
                                                  onClick={() =>
                                                    handleSelectImageFromGallery(
                                                      img,
                                                    )
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                    border: "2px solid #e0e0e0",
                                                    borderRadius: "10px",
                                                    overflow: "hidden",
                                                    transition: "all 0.2s",
                                                    position: "relative",
                                                  }}
                                                  onMouseEnter={(e) => {
                                                    e.currentTarget.style.transform =
                                                      "translateY(-4px)";
                                                    e.currentTarget.style.borderColor =
                                                      "#a070b9";
                                                    e.currentTarget.style.boxShadow =
                                                      "0 6px 16px rgba(160, 112, 185, 0.3)";
                                                  }}
                                                  onMouseLeave={(e) => {
                                                    e.currentTarget.style.transform =
                                                      "translateY(0)";
                                                    e.currentTarget.style.borderColor =
                                                      "#e0e0e0";
                                                    e.currentTarget.style.boxShadow =
                                                      "none";
                                                  }}
                                                >
                                                  <img
                                                    src={img}
                                                    alt={t(
                                                      "Products.modalAdd.tab2.galleryImageAlt",
                                                      { index: idx + 1 },
                                                    )}
                                                    style={{
                                                      width: "100%",
                                                      height: "140px",
                                                      objectFit: "cover",
                                                    }}
                                                  />
                                                </div>
                                              ))}
                                            </div>
                                          ) : (
                                            <div className="text-center py-5">
                                              <i
                                                className="bi bi-folder2-open"
                                                style={{
                                                  fontSize: "48px",
                                                  color: "#ccc",
                                                }}
                                              ></i>
                                              <p className="mt-3 text-muted">
                                                {t(
                                                  "Products.modalAdd.tab2.noGalleryImages",
                                                )}
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {/***--------------------------------------------------------------------------------------------------------------------------------------- */}
                              </Form.Group>
                            ))}

                            <div className="col-3">
                              <button
                                type="button"
                                className="bi bi-node-plus-fill"
                                onClick={() => {
                                  updateFieldChanged(index, 0, "e", "add");
                                }}
                              ></button>
                            </div>
                          </div>
                        </div>
                      ) : null,
                    )}
                  </div>

                  {/*-----------------------------------------------------------------------------------------------------------------------------------------*/}
                  <div className="border border-gray-300 rounded-lg w-full bg-white flex flex-col gap-2 my-3">
                    {/* Header */}
                    <div className="flex items-center justify-between bg-[#fbf5ff] p-2 rounded-lg border-b border-[#eee] ">
                      <div className="flex items-center gap-2 text-red-500 hover:text-red-700 p-1">
                        <span className="text-xl">
                          {/* Icon */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#707070"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-badge-percent"
                          >
                            <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                            <path d="m15 9-6 6" />
                            <path d="M9 9h.01" />
                            <path d="M15 15h.01" />
                          </svg>
                        </span>
                        <span className="text-gray-700 font-medium">
                          {t("Products.modalAdd.tab2.offersByQuantity.title")}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              {t(
                                "Products.modalAdd.tab2.offersByQuantity.tooltip",
                              )}
                            </Tooltip>
                          }
                        >
                          <i className="bi bi-info-circle-fill text-[#0866ff] text-xl"></i>
                        </OverlayTrigger>
                      </div>
                    </div>

                    <div className="row gap-3 p-2">
                      {data.offers.map((offer, index) => (
                        <div className="col-12" key={index}>
                          <div className="flex flex-nowrap items-center gap-2 w-full">
                            {/* وصف العرض - جعلناه يأخذ المساحة الأكبر flex-[2] أو flex-grow */}
                            <div className="flex-[2.5] min-w-[150px]">
                              {index === 0 && (
                                <label className="text-[#444] text-[13px] font-medium mb-1 block">
                                  {t(
                                    "Products.modalAdd.tab2.offersByQuantity.descriptionLabel",
                                  )}
                                </label>
                              )}
                              <input
                                placeholder={t(
                                  "Products.modalAdd.tab2.offersByQuantity.descriptionPlaceholder",
                                  { index: index + 1 },
                                )}
                                type="text"
                                value={offer.title}
                                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 px-2"
                                onChange={(e) =>
                                  updateFieldChanged2(
                                    index,
                                    "title",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>

                            {/* الكمية المطلوبة - مساحة صغيرة محددة */}
                            <div className="w-20 md:w-24">
                              {index === 0 && (
                                <label className="text-[#444] text-[12px] font-medium mb-1 block truncate">
                                  {t(
                                    "Products.modalAdd.tab2.offersByQuantity.quantityLabel",
                                  )}
                                </label>
                              )}
                              <input
                                placeholder="0"
                                type="number"
                                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 px-0 text-center"
                                value={offer.qty || ""}
                                onChange={(e) =>
                                  updateFieldChanged2(
                                    index,
                                    "qty",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>

                            {/* سعر العرض - مساحة صغيرة محددة */}
                            <div className="w-20 md:w-24">
                              {index === 0 && (
                                <label className="text-[#444] text-[12px] font-medium mb-1 block truncate">
                                  {t(
                                    "Products.modalAdd.tab2.offersByQuantity.priceLabel",
                                  )}
                                </label>
                              )}
                              <input
                                placeholder="0.00"
                                type="number"
                                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 px-0 text-center"
                                value={offer.price || ""}
                                onChange={(e) =>
                                  updateFieldChanged2(
                                    index,
                                    "price",
                                    e.target.value,
                                  )
                                }
                              />
                            </div>

                            {/* الرقم/العدد - مساحة صغيرة محددة */}
                            <div className="w-16 md:w-20">
                              {index === 0 && (
                                <label className="text-[#444] text-[12px] font-medium mb-1 block truncate">
                                  {t(
                                    "Products.modalAdd.tab2.offersByQuantity.numberLabel",
                                  )}
                                </label>
                              )}
                              <input
                                placeholder="0"
                                type="number"
                                className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2 px-0 text-center"
                                value={offer.number || ""}
                                onChange={(e) =>
                                  updateFieldChanged2(
                                    index,
                                    "number",
                                    e.target.value === ""
                                      ? ""
                                      : Number(e.target.value),
                                  )
                                }
                              />
                            </div>

                            {/* الشحن المجاني (Checkbox) */}
                            <div className="flex items-center justify-center pt-1">
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip>
                                    {t(
                                      "Products.modalAdd.tab2.offersByQuantity.freeShippingTooltip",
                                    )}
                                  </Tooltip>
                                }
                              >
                                <Form.Check
                                  inline
                                  name={`group${index}`}
                                  type="checkbox"
                                  className="m-0 custom-checkbox"
                                  checked={offer.deleveryoffre}
                                  onChange={() => {
                                    const updatedOffers = [...data.offers];
                                    updatedOffers[index].deleveryoffre =
                                      !offer.deleveryoffre;
                                    setData({ ...data, offers: updatedOffers });
                                  }}
                                />
                              </OverlayTrigger>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/**-------------------------------------------------------------------------------------------------------- */}

                  <div>
                    <div className="col-12"></div>
                  </div>
                  <div className="border border-gray-300 rounded-lg w-full bg-white flex flex-col gap-2 mb-3">
                    {/* Header */}
                    <div className="flex items-center justify-between bg-[#fbf5ff] p-2 rounded-lg border-b border-[#eee] ">
                      <div className="flex items-center gap-2">
                        <span className="text-xl text-red-500 hover:text-red-700 p-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#707070"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-file-spreadsheet"
                          >
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                            <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                            <path d="M8 13h2" />
                            <path d="M14 13h2" />
                            <path d="M8 17h2" />
                            <path d="M14 17h2" />
                          </svg>
                        </span>
                        <span className="text-gray-700 font-medium">
                          {t("Products.modalAdd.tab2.googleSheet.title")}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              {" "}
                              {t("Products.modalAdd.tab2.googleSheet.tooltip")}
                            </Tooltip>
                          }
                        >
                          <i className="bi bi-info-circle-fill text-[#0866ff] text-xl"></i>
                        </OverlayTrigger>
                      </div>
                    </div>

                    {/* Inputs Section */}
                    <div className="flex items-center gap-2 p-2">
                      <input
                        type="text"
                        placeholder={t(
                          "Products.modalAdd.tab2.googleSheet.placeholder",
                        )}
                        value={data.googleSheetP}
                        onChange={(e) =>
                          setData({ ...data, googleSheetP: e.target.value })
                        }
                        className="border border-gray-300 rounded-md px-3 py-2 w-full"
                      />
                      <button className="text-gray-500 p-2 border border-gray-300 rounded-md bg-gray-50">
                        <div
                          className="w-8  flex items-center justify-center cursor-pointer"
                          onClick={() => {
                            const youtubeLink =
                              "https://youtu.be/P0a5VUYVF8Q?si=A0F07ORO4iUsDJ9e";
                            const mobileLink =
                              "vnd.youtube://www.youtube.com/watch?v=P0a5VUYVF8Q";

                            if (
                              /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                navigator.userAgent,
                              )
                            ) {
                              window.location.href = mobileLink;
                            } else {
                              window.open(youtubeLink, "_blank");
                            }
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ababab"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-tv-minimal-play"
                          >
                            <path d="M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z" />
                            <path d="M7 21h10" />
                            <rect width="20" height="14" x="2" y="3" rx="2" />
                          </svg>
                        </div>
                      </button>
                    </div>

                    <div className="flex items-center gap-2">
                      <div className="flex items-center justify-right my-1 mx-1 mb-1">
                        <Form.Check
                          inline
                          name="group1"
                          type={"checkbox"}
                          className="mx-2"
                          checked={data.googleSheetPActive} // Safe access
                          onChange={() => {
                            const updatedData = {
                              ...data,
                              googleSheetPActive: !data.googleSheetPActive,
                            };
                            setData(updatedData);
                          }}
                        />
                        <label className="">
                          {t(
                            "Products.modalAdd.tab2.googleSheet.checkboxLabel",
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                  {/**-------------------------------------------------------------------------------------------------------- */}
                  <div className="border border-gray-300 rounded-lg shadow-sm w-full bg-white flex flex-col gap-2 mb-3">
                    {/* Header */}
                    <div className="flex items-center justify-between bg-[#fbf5ff] p-2 rounded-lg border-b border-[#eee] ">
                      <div className="flex items-center gap-2">
                        <span className="text-xl text-red-500 hover:text-red-700 p-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#707070"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-badge-percent"
                          >
                            <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                            <path d="m15 9-6 6" />
                            <path d="M9 9h.01" />
                            <path d="M15 15h.01" />
                          </svg>
                        </span>
                        <span className="text-gray-700 font-medium">
                          {" "}
                          {t("Products.modalAdd.tab2.stayOffers.title")}{" "}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              {" "}
                              {t("Products.modalAdd.tab2.stayOffers.tooltip")}
                            </Tooltip>
                          }
                        >
                          <i className="bi bi-info-circle-fill text-[#0866ff] text-xl"></i>
                        </OverlayTrigger>
                      </div>
                    </div>

                    {/* Inputs Section */}
                    <div className="flex items-center gap-2 p-2">
                      <input
                        type="tel"
                        placeholder={t(
                          "Products.modalAdd.tab2.stayOffers.placeholder_discountTotal",
                        )}
                        value={data.discount?.discountTotal || ""} // Safe access
                        onChange={(e) => {
                          const value = e.target.value
                            ? parseFloat(e.target.value)
                            : 0; // Ensure numeric value
                          updateDiscountField("discountTotal", value);
                        }}
                        className="border border-gray-300 rounded-md px-3 py-2 w-full"
                      />
                      <button className="text-gray-500 p-2 border border-gray-300 rounded-md bg-gray-50">
                        <div
                          className="w-8  flex items-center justify-center cursor-pointer"
                          onClick={() => {
                            const youtubeLink =
                              "https://youtu.be/P0a5VUYVF8Q?si=A0F07ORO4iUsDJ9e";
                            const mobileLink =
                              "vnd.youtube://www.youtube.com/watch?v=P0a5VUYVF8Q";

                            if (
                              /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                                navigator.userAgent,
                              )
                            ) {
                              window.location.href = mobileLink;
                            } else {
                              window.open(youtubeLink, "_blank");
                            }
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ababab"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-tv-minimal-play"
                          >
                            <path d="M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z" />
                            <path d="M7 21h10" />
                            <rect width="20" height="14" x="2" y="3" rx="2" />
                          </svg>
                        </div>
                      </button>
                    </div>
                    <input
                      type="tel"
                      placeholder={t(
                        "Products.modalAdd.tab2.stayOffers.placeholder_second",
                      )}
                      value={data.discount?.second || ""} // Safe access
                      onChange={(e) => {
                        const value = e.target.value
                          ? parseFloat(e.target.value)
                          : 0; // Ensure numeric value
                        updateDiscountField("second", value);
                      }}
                      className="border border-gray-300 rounded-md px-3 py-2  mx-2"
                    />

                    <div className="flex items-center gap-2"></div>

                    <div className="flex items-center gap-2">
                      <div className="flex items-center justify-right my-1 mx-1 mb-1">
                        <Form.Check
                          inline
                          name="group1"
                          type={"checkbox"}
                          className="mx-2"
                          checked={data.discount?.activeStay || false} // Safe access
                          onChange={(e) =>
                            updateDiscountField("activeStay", e.target.checked)
                          }
                        />
                        <label className="">
                          {t("Products.modalAdd.tab2.stayOffers.checkboxLabel")}
                        </label>
                      </div>
                    </div>
                  </div>

                  {store?.cloakingActive && (
                    <div className="border border-gray-300 rounded-lg shadow-sm w-full bg-white flex flex-col gap-2 mb-3">
                      {/* Header */}
                      <div className="flex items-center justify-between bg-[#fbf5ff] p-2 rounded-lg border-b border-[#eee]">
                        <div className="flex items-center gap-2">
                          <span className="text-xl text-red-500 hover:text-red-700 p-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#707070"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-shield"
                            >
                              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                            </svg>
                          </span>
                          <span className="text-gray-700 font-medium">
                            {t("Products.modalAdd.tab2.cloaking.title")}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {t("Products.modalAdd.tab2.cloaking.tooltip")}
                              </Tooltip>
                            }
                          >
                            <i className="bi bi-info-circle-fill text-[#0866ff] text-xl"></i>
                          </OverlayTrigger>
                        </div>
                      </div>
                      {/* Search Input with YouTube Button */}
                      <div className="flex items-center gap-2 p-2">
                        <div className="relative flex-1">
                          <input
                            type="text"
                            placeholder={t(
                              "Products.modalAdd.tab2.cloaking.searchPlaceholder",
                            )}
                            value={searchQuery}
                            onChange={(e) => {
                              setSearchQuery(e.target.value);
                              setIsDropdownOpen(true);
                            }}
                            onFocus={() => setIsDropdownOpen(true)}
                            onClick={(e) => {
                              if (isDropdownOpen) {
                                setIsDropdownOpen(false);
                              } else {
                                setIsDropdownOpen(true);
                              }
                            }}
                            className="border border-gray-300 rounded-md px-3 py-2 w-full text-right pr-10"
                          />
                          <div className="absolute left-3 top-2.5 text-gray-400">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-search"
                            >
                              <circle cx="11" cy="11" r="8" />
                              <path d="m21 21-4.3-4.3" />
                            </svg>
                          </div>
                        </div>

                        <button className="text-gray-500 p-2 border border-gray-300 rounded-md bg-gray-50">
                          <div className="w-8 flex items-center justify-center cursor-pointer">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#ababab"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-tv-minimal-play"
                            >
                              <path d="M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z" />
                              <path d="M7 21h10" />
                              <rect width="20" height="14" x="2" y="3" rx="2" />
                            </svg>
                          </div>
                        </button>
                      </div>
                      {/* Country Dropdown List */}
                      {isDropdownOpen && (
                        <div
                          className="mt-1 mx-2 max-h-60 overflow-y-auto border border-gray-300 rounded-md bg-white z-10"
                          onBlur={() => setIsDropdownOpen(false)}
                          tabIndex={0}
                        >
                          {filteredCountries.length > 0 ? (
                            filteredCountries.map((country) => (
                              <div
                                key={country.alpha2_code}
                                className={`p-2 hover:bg-gray-100 cursor-pointer text-right flex justify-between items-center ${
                                  selectedCountries.some(
                                    (c) =>
                                      c.alpha2_code === country.alpha2_code,
                                  )
                                    ? "bg-purple-50"
                                    : ""
                                }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (
                                    selectedCountries.some(
                                      (c) =>
                                        c.alpha2_code === country.alpha2_code,
                                    )
                                  ) {
                                    setSelectedCountries(
                                      selectedCountries.filter(
                                        (c) =>
                                          c.alpha2_code !== country.alpha2_code,
                                      ),
                                    );
                                  } else {
                                    setSelectedCountries([
                                      ...selectedCountries,
                                      {
                                        code: country.alpha2_code,
                                        name: country.arabic_name,
                                        englishName: country.english_name,
                                        phoneCode: country.phone_code,
                                      },
                                    ]);
                                  }
                                  setIsDropdownOpen(false);
                                  setSearchQuery("");
                                }}
                              >
                                <span>{country.arabic_name}</span>
                                <span className="text-xs text-gray-500 ml-2">
                                  +{country.phone_code}
                                </span>
                              </div>
                            ))
                          ) : (
                            <div className="p-2 text-right text-gray-500">
                              {t("Products.modalAdd.tab2.cloaking.noResults")}
                            </div>
                          )}
                        </div>
                      )}
                      {/* Selected Countries Display */}
                      {selectedCountries.length > 0 && (
                        <div className="flex flex-wrap gap-2 p-2">
                          {selectedCountries.map((country) => (
                            <div
                              key={country.code}
                              className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm flex items-center gap-1"
                            >
                              {country.name}
                              <span className="text-xs">
                                (+{country.phoneCode})
                              </span>
                              <button
                                className="text-purple-500 hover:text-purple-700"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedCountries(
                                    selectedCountries.filter(
                                      (c) => c.code !== country.code,
                                    ),
                                  );
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-x"
                                >
                                  <path d="M18 6 6 18" />
                                  <path d="m6 6 12 12" />
                                </svg>
                              </button>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* CloakingTown Data Display */}
                      {cloakingTownRawData.length > 0 && (
                        <div className="mt-2 p-2 border-t border-gray-200">
                          <div className="font-medium text-gray-700 mb-2 text-right">
                            {t(
                              "Products.modalAdd.tab2.cloaking.hiddenCountriesLabel",
                            )}
                          </div>
                          <div className="flex flex-wrap gap-2">
                            {cloakingTownRawData.map((countryCode) => {
                              const countryDetails = countriesData.find(
                                (c) => c.alpha2_code === countryCode,
                              );
                              return countryDetails ? (
                                <div
                                  key={countryCode}
                                  className="bg-gray-100 text-gray-800 px-3 py-1 rounded-md text-sm flex items-center gap-1"
                                >
                                  <span>{countryDetails.arabic_name}</span>
                                  <span className="text-xs text-gray-500">
                                    ({countryCode})
                                  </span>
                                  <button
                                    className="text-red-500 hover:text-red-700 ml-1"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      onDeleteCountry(countryCode);
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-x"
                                    >
                                      <path d="M18 6 6 18" />
                                      <path d="m6 6 12 12" />
                                    </svg>
                                  </button>
                                </div>
                              ) : (
                                <div
                                  key={countryCode}
                                  className="bg-gray-100 text-gray-800 px-3 py-1 rounded-md text-sm flex items-center gap-1"
                                >
                                  {countryCode}
                                  <button
                                    className="text-red-500 hover:text-red-700 ml-1"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      onDeleteCountry(countryCode);
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-x"
                                    >
                                      <path d="M18 6 6 18" />
                                      <path d="m6 6 12 12" />
                                    </svg>
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* <FoorchatAdsIdsManager data={data} setData={setData} /> */}

                  {/**-------------------------------------------------------------------------------------------------------- */}
                </div>
              )}

              {activeTab === "tab3" && (
                <div className="border min-h-full border-gray-300 rounded-lg shadow-sm w-full bg-white flex flex-col gap-2 mb-3">
                  {/* Header */}
                  <div className="flex items-center justify-between bg-[#fbf5ff] p-2 rounded-lg border-b border-[#eee]">
                    <div className="flex items-center gap-2">
                      <button className="text-red-500 hover:text-red-700 p-1">
                        <span className="text-xl">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#707070"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-map-pinned"
                          >
                            <path d="M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0" />
                            <circle cx="12" cy="8" r="2" />
                            <path d="M8.714 14h-3.71a1 1 0 0 0-.948.683l-2.004 6A1 1 0 0 0 3 22h18a1 1 0 0 0 .948-1.316l-2-6a1 1 0 0 0-.949-.684h-3.712" />
                          </svg>
                        </span>
                      </button>
                      <span className="text-gray-700 font-medium">
                        {t("Products.modalAdd.tab3.regionPricingTitle")}
                      </span>
                    </div>
                    <div className="flex items-center gap-2">
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip>
                            {t("Products.modalAdd.tab3.regionPricingTooltip")}
                          </Tooltip>
                        }
                      >
                        <i className="bi bi-info-circle-fill text-[#0866ff] text-xl"></i>
                      </OverlayTrigger>
                    </div>
                  </div>

                  <div className="flex flex-col gap-2 my-1">
                    <div className="flex items-center">
                      <Form.Check
                        inline
                        name="deliveryOption"
                        type="radio"
                        className="mx-2"
                        value="store"
                        checked={deliveryOption === "store"}
                        onChange={(e) =>
                          handleDeliveryOptionChange(e.target.value)
                        }
                      />
                      <label>
                        {t("Products.modalAdd.tab3.useStorePrice")}
                        <a
                          href="/settings/delevery"
                          className="mx-2 text-blue-600 underline text-sm"
                        >
                          {t("Products.modalAdd.tab3.link-prices")}
                        </a>
                      </label>
                    </div>

                    <div className="flex items-center">
                      <Form.Check
                        inline
                        name="deliveryOption"
                        type="radio"
                        className="mx-2"
                        value="constant"
                        checked={deliveryOption === "constant"}
                        onChange={(e) =>
                          handleDeliveryOptionChange(e.target.value)
                        }
                      />
                      <label>
                        {t("Products.modalAdd.tab3.setConstantPrice")}
                      </label>
                    </div>

                    {deliveryOption === "constant" && (
                      <div className="flex items-center gap-2 p-2">
                        <input
                          type="number"
                          placeholder={t(
                            "Products.modalAdd.tab3.constantPricePlaceholder",
                          )}
                          value={constantPriceValue}
                          onChange={(e) => {
                            const value = Number(e.target.value);
                            setConstantPriceValue(value);
                            setData((prev) => ({
                              ...prev,
                              constantPrice: value,
                            }));
                          }}
                          className="border border-gray-300 rounded-md px-3 py-2 w-full"
                        />
                      </div>
                    )}

                    {isAlgeria && (
                      <div className="flex items-center">
                        <Form.Check
                          inline
                          name="deliveryOption"
                          type="radio"
                          className="mx-2"
                          value="default"
                          checked={deliveryOption === "default"}
                          onChange={(e) =>
                            handleDeliveryOptionChange(e.target.value)
                          }
                        />
                        <label>
                          {t("Products.modalAdd.tab3.defaultPricePerRegion")}
                        </label>
                      </div>
                    )}

                    {deliveryOption === "default" && (
                      <div>
                        <Card className="m-2">
                          <div className="m-3 d-flex justify-content-center">
                            <Form.Control
                              className="mx-2"
                              style={{ width: "500px" }}
                              placeholder={t(
                                "Products.modalAdd.tab3.searchWilayaPlaceholder",
                              )}
                              value={filter}
                              onChange={(e) => setFilter(e.target.value)}
                            />
                          </div>
                          <div className="grid grid-cols-2 lg:grid-cols-3">
                            {(
                              (data?.states && Array.isArray(data.states)
                                ? data.states
                                : DEFAULT_WILAYAS) || []
                            )
                              .filter(
                                (state) =>
                                  state.name
                                    .toLowerCase()
                                    .includes(filter.toLowerCase()) ||
                                  state.wilaya_code.includes(filter),
                              )
                              .map((state) => {
                                const isVisible = !state.hide;

                                return (
                                  <div className="" key={state.wilaya_code}>
                                    <Card
                                      className={`m-1 shadow-sm ${
                                        isVisible ? "opacity-75" : ""
                                      }`}
                                    >
                                      <div className="d-flex align-items-center">
                                        <Form.Check
                                          inline
                                          name="hide"
                                          type="checkbox"
                                          className="mx-2"
                                          checked={state.hide}
                                          onChange={(e) => {
                                            const isChecked = e.target.checked;
                                            const currentStates =
                                              data.states || DEFAULT_WILAYAS;
                                            setData((prev) => ({
                                              ...prev,
                                              states: currentStates.map((w) =>
                                                w.wilaya_code ===
                                                state.wilaya_code
                                                  ? {
                                                      ...w,
                                                      hide: isChecked,
                                                      hidestopdesk: !isChecked
                                                        ? true
                                                        : w.hidestopdesk,
                                                    }
                                                  : w,
                                              ),
                                            }));
                                          }}
                                        />
                                        <p
                                          className="pt-2 mx-2"
                                          style={{ width: "250px" }}
                                        >
                                          {state.name} ({state.wilaya_code})
                                        </p>
                                        <Form.Control
                                          type="number"
                                          value={state.price}
                                          onChange={(e) => {
                                            const newPrice = e.target.value;
                                            const currentStates =
                                              data.states || DEFAULT_WILAYAS;

                                            setData((prev) => ({
                                              ...prev,
                                              states: currentStates.map((w) =>
                                                w.wilaya_code ===
                                                state.wilaya_code
                                                  ? { ...w, price: newPrice }
                                                  : w,
                                              ),
                                            }));
                                          }}
                                          className="mx-2"
                                          min="0"
                                          step="100"
                                          disabled={!state.hide}
                                        />
                                      </div>
                                      <Card
                                        className={`m-2 shadow-sm ${
                                          state.hide ? "" : "opacity-75"
                                        }`}
                                      >
                                        <div className="d-flex align-items-center">
                                          <Form.Check
                                            inline
                                            name="hidestopdesk"
                                            type="checkbox"
                                            checked={state.hidestopdesk}
                                            onChange={(e) => {
                                              const isChecked =
                                                e.target.checked;
                                              const currentStates =
                                                data.states || DEFAULT_WILAYAS;
                                              setData((prev) => ({
                                                ...prev,
                                                states: currentStates.map(
                                                  (w) =>
                                                    w.wilaya_code ===
                                                    state.wilaya_code
                                                      ? {
                                                          ...w,
                                                          hidestopdesk:
                                                            isChecked,
                                                        }
                                                      : w,
                                                ),
                                              }));
                                            }}
                                            disabled={!state.hide}
                                          />

                                          <Form.Control
                                            name="stopdesk"
                                            placeholder={t(
                                              "Products.modalAdd.tab3.officePlaceholder",
                                            )}
                                            value={state.stopdesk || ""}
                                            onChange={(e) => {
                                              const { name, value } = e.target;
                                              const currentStates =
                                                data.states || DEFAULT_WILAYAS;
                                              setData((prev) => ({
                                                ...prev,
                                                states: currentStates.map(
                                                  (w) =>
                                                    w.wilaya_code ===
                                                    state.wilaya_code
                                                      ? { ...w, [name]: value }
                                                      : w,
                                                ),
                                              }));
                                            }}
                                            disabled={
                                              !state.hidestopdesk || !state.hide
                                            }
                                            className="mx-1"
                                          />

                                          <Form.Control
                                            name="pricestopdesk"
                                            placeholder={t(
                                              "Products.modalAdd.tab3.pricePlaceholder",
                                            )}
                                            value={state.pricestopdesk || ""}
                                            onChange={(e) => {
                                              const { name, value } = e.target;
                                              const currentStates =
                                                data.states || DEFAULT_WILAYAS;
                                              setData((prev) => ({
                                                ...prev,
                                                states: currentStates.map(
                                                  (w) =>
                                                    w.wilaya_code ===
                                                    state.wilaya_code
                                                      ? { ...w, [name]: value }
                                                      : w,
                                                ),
                                              }));
                                            }}
                                            type="number"
                                            min="0"
                                            disabled={
                                              !state.hidestopdesk || !state.hide
                                            }
                                            className="mx-1"
                                          />
                                        </div>
                                      </Card>
                                    </Card>
                                  </div>
                                );
                              })}
                          </div>
                        </Card>
                      </div>
                    )}

                    <div className="flex items-center">
                      <Form.Check
                        inline
                        name="deliveryOption"
                        type="radio"
                        className="mx-2"
                        value="free"
                        checked={deliveryOption === "free"}
                        onChange={(e) =>
                          handleDeliveryOptionChange(e.target.value)
                        }
                      />
                      <label>{t("Products.modalAdd.tab3.freeDelivery")}</label>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "tab5" && store?.foorchat?.enabled === true && (
                <div className="border border-gray-300 rounded-lg shadow-sm w-full bg-white flex flex-col gap-6 p-4 mb-3">
                  <div>
                    <label className="text-[#444] text-[13px] font-medium mb-2 block">
                      {t("Products.modalAdd.tab5.customizeButton")}
                    </label>

                    <div className="flex justify-center mb-3">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.currentTarget.classList.add("scale-95");
                          setTimeout(
                            () => e.currentTarget.classList.remove("scale-95"),
                            150,
                          );
                        }}
                        className="px-8 py-3 rounded-lg font-semibold text-white bg-[#a070b9] hover:bg-[#8d5da7] transition-transform duration-150 shadow-md"
                      >
                        {data.botButton || t("Products.modalAdd.tab5.button")}
                      </button>
                    </div>

                    <input
                      type="text"
                      value={
                        data.botButton || t("Products.modalAdd.tab5.button")
                      }
                      onChange={(e) =>
                        setData({ ...data, botButton: e.target.value })
                      }
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2.5 px-3"
                      placeholder={t("Products.modalAdd.tab5.button")}
                      dir={i18n.language === "ar" ? "rtl" : "ltr"}
                    />
                  </div>

                  <div>
                    <label className="text-[#444] text-[13px] font-medium mb-2 block">
                      {t("Products.modalAdd.tab5.description")}
                    </label>
                    <textarea
                      rows={6}
                      value={data.botDescription || ""}
                      onChange={(e) =>
                        setData({ ...data, botDescription: e.target.value })
                      }
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2.5 px-3 resize-y"
                      placeholder={t(
                        "Products.modalAdd.tab5.placeholderDescription",
                      )}
                    />
                  </div>

                  <div>
                    <label className="text-[#444] text-[13px] font-medium mb-2 block">
                      {t("Products.modalAdd.tab5.phone")}
                    </label>
                    <input
                      type="tel"
                      inputMode="numeric"
                      value={data.botPhone || ""}
                      onChange={(e) => {
                        const phone = e.target.value.replace(/\D/g, "");
                        setData({ ...data, botPhone: phone });
                      }}
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2.5 px-3"
                      placeholder={t("Products.modalAdd.tab5.phonePlaceholder")}
                      dir={i18n.language === "ar" ? "rtl" : "ltr"}
                    />
                  </div>

                  <div>
                    <label className="text-[#444] text-[13px] font-medium mb-2 block">
                      {t("Products.modalAdd.tab5.deliverySociety")}
                    </label>
                    <input
                      type="text"
                      value={data.deliverySociety || ""}
                      onChange={(e) =>
                        setData({ ...data, deliverySociety: e.target.value })
                      }
                      className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2.5 px-3"
                      placeholder={t(
                        "Products.modalAdd.tab5.deliverySocietyPlaceholder",
                      )}
                      dir={i18n.language === "ar" ? "rtl" : "ltr"}
                    />
                  </div>

                  <div>
                    <label className="text-[#444] text-[13px] font-medium mb-2 block">
                      {t("Products.modalAdd.tab5.adsIds")}
                    </label>

                    <div className="flex gap-2 mb-3">
                      <input
                        type="text"
                        value={newAdsId}
                        onChange={(e) => setNewAdsId(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleAddAdsId();
                          }
                        }}
                        className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full py-2.5 px-3"
                        placeholder={t(
                          "Products.modalAdd.tab5.adsIdPlaceholder",
                        )}
                        dir={i18n.language === "ar" ? "rtl" : "ltr"}
                      />
                      <button
                        type="button"
                        onClick={handleAddAdsId}
                        className="px-4 py-2.5 bg-[#a070b9] hover:bg-[#8d5da7] text-white text-sm font-medium rounded-lg whitespace-nowrap transition"
                      >
                        {t("Products.modalAdd.tab5.addAdsId")}
                      </button>
                    </div>

                    {Array.isArray(data.adsIds) && data.adsIds.length > 0 && (
                      <div className="flex flex-wrap gap-2">
                        {data.adsIds.map((id, index) => (
                          <div
                            key={`${id}-${index}`}
                            className="bg-purple-100 text-purple-800 px-3 py-1.5 rounded-full text-sm flex items-center gap-2"
                          >
                            <span className="font-mono">{id}</span>
                            <button
                              type="button"
                              onClick={() => handleRemoveAdsId(index)}
                              className="text-purple-500 hover:text-purple-700 leading-none"
                            >
                              <CloseOutlined style={{ fontSize: 12 }} />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {activeTab === "tab4" && (
                <DigitalProductForm product={data} onProductUpdate={setData} />
              )}
            </div>
          </div>
          <Modal.Footer className="modal-footer-fixed">
            <button
              className="w-full mt-2 p-2.5 flex-1 text-gray-800 rounded-md outline-none border ring-offset-2 ring-purple-400 focus:ring-2"
              variant="danger"
              onClick={handleClose}
              type="button"
            >
              {t("Products.modalAdd.cancel")}
            </button>

            {!loading ? (
              <button
                variant="success"
                type="submit"
                onClick={handleSubmit}
                className="w-full mt-2 p-2.5 flex-1 text-white bg-[#a070b9] rounded-md outline-none ring-offset-2 ring-purple-400 focus:ring-2"
              >
                {t("Products.modalAdd.save.save")}
              </button>
            ) : (
              <Button variant="success" disabled>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                {t("Products.modalAdd.uploading")}
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default ModelAdd;
